webpackJsonp([79611799117203,60335399758886],{

/***/ 140:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(273);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(140);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The divider component will pass all other props such as style or
	 * event listeners on to the component.
	 */
	var Divider = function (_PureComponent) {
	  _inherits(Divider, _PureComponent);
	
	  function Divider() {
	    _classCallCheck(this, Divider);
	
	    return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	  }
	
	  _createClass(Divider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          inset = _props.inset,
	          vertical = _props.vertical,
	          props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
	
	      var Component = vertical ? 'div' : 'hr';
	
	      return _react2.default.createElement(Component, _extends({}, props, {
	        className: (0, _classnames2.default)('md-divider', {
	          'md-divider--vertical': vertical,
	          'md-divider--inset': inset
	        }, className)
	      }));
	    }
	  }]);
	
	  return Divider;
	}(_react.PureComponent);
	
	Divider.propTypes = {
	  /*
	   * An optional style to apply to the divider.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the divider.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this divider should be inset relative to it's container
	   * component. This means that if it is in a `List` with `Avatar`, it
	   * will start the divider  to the left of the main text in the list.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the divider should be vertical instead of horizontal.
	   */
	  vertical: _propTypes2.default.bool
	};
	exports.default = Divider;
	//# sourceMappingURL=Divider.js.map

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _media = __webpack_require__(579);
	
	var _CSSTransitionGroupTick = __webpack_require__(56);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(28);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _mapToListParts = __webpack_require__(594);
	
	var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	var _controlled = __webpack_require__(102);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _Paper = __webpack_require__(147);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Portal = __webpack_require__(97);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _List = __webpack_require__(99);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Overlay = __webpack_require__(559);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _isType = __webpack_require__(215);
	
	var _DrawerTypes = __webpack_require__(214);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var oneOfDrawerTypes = _propTypes2.default.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);
	
	/**
	 * The `Drawer` component is used for having a sliding panel of content or navigation
	 * that appears from the side of a screen.
	 *
	 * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
	 * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
	 * and it isn't much more work to create another drawer.
	 */
	
	var Drawer = function (_PureComponent) {
	  _inherits(Drawer, _PureComponent);
	
	  _createClass(Drawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet,
	     *    and desktop type/min widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
	      var mobileMinWidth = props.mobileMinWidth,
	          tabletMinWidth = props.tabletMinWidth,
	          desktopMinWidth = props.desktopMinWidth,
	          mobileType = props.mobileType,
	          tabletType = props.tabletType,
	          desktopType = props.desktopType,
	          constantType = props.constantType;
	
	      if (typeof window === 'undefined') {
	        var _type = constantType && props.type ? props.type : mobileType;
	        return { mobile: true, tablet: false, desktop: false, type: _type };
	      }
	
	      var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
	      var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
	      var desktop = Drawer.matchesMedia(desktopMinWidth);
	
	      var type = void 0;
	      if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
	        type = props.type;
	      } else if (desktop) {
	        type = desktopType;
	      } else if (tablet) {
	        type = tabletType;
	      } else {
	        type = mobileType;
	      }
	
	      return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
	    }
	
	    /**
	     * Simply does a `window.matchMedia(query)` where the query gets defined as a min width
	     * and optional max width.
	     *
	     * @param {number} min - The min width for the media query.
	     * @param {number=} max - An optional max width to include for the media query.
	     * @return {boolean} true if the media matches.
	     */
	
	  }, {
	    key: 'matchesMedia',
	    value: function matchesMedia(min, max) {
	      var media = 'screen and (min-width: ' + min + 'px)';
	      if (max) {
	        media += ' and (max-width: ' + max + 'px)';
	      }
	
	      return window.matchMedia(media).matches;
	    }
	  }]);
	
	  function Drawer(props) {
	    _classCallCheck(this, Drawer);
	
	    var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultVisible = props.defaultVisible,
	        defaultMedia = props.defaultMedia,
	        overlay = props.overlay;
	
	
	    _this.state = {
	      mobile: defaultMedia === 'mobile',
	      tablet: defaultMedia === 'tablet',
	      desktop: defaultMedia === 'desktop',
	      animating: false,
	      overlayActive: false,
	      drawerActive: false
	    };
	
	    if (typeof props.type === 'undefined') {
	      _this.state.type = props[defaultMedia + 'Type'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'type');
	    _this._initialFix = true;
	
	    if (typeof props.visible === 'undefined') {
	      var _visible = (0, _isType.isPermanent)(type) || (0, _isType.isMini)(type);
	      if (!_visible && typeof defaultVisible !== 'undefined') {
	        _visible = defaultVisible;
	      }
	
	      _this.state.visible = _visible;
	    }
	
	    var visible = (0, _getField2.default)(props, _this.state, 'visible');
	
	    _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
	    _this.state.drawerActive = visible;
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window !== 'undefined') {
	        this._updateType(this.props);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!(0, _isType.isMini)((0, _getField2.default)(this.props, this.state, 'type'))) {
	        window.addEventListener('resize', this._updateMedia);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          mobileMinWidth = _props.mobileMinWidth,
	          mobileType = _props.mobileType,
	          tabletMinWidth = _props.tabletMinWidth,
	          tabletType = _props.tabletType,
	          desktopMinWidth = _props.desktopMinWidth,
	          desktopType = _props.desktopType;
	
	
	      if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
	        this._updateType(nextProps);
	      }
	
	      var visible = nextProps.visible,
	          transitionDuration = nextProps.transitionDuration,
	          overlay = nextProps.overlay;
	
	      if (this.props.visible === nextProps.visible) {
	        return;
	      }
	
	      var type = (0, _getField2.default)(nextProps, this.state, 'type');
	      this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	
	      if (this._closeTimeout) {
	        clearTimeout(this._closeTimeout);
	      }
	
	      window.removeEventListener('resize', this._updateMedia);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _state = this.state,
	          overlayActive = _state.overlayActive,
	          drawerActive = _state.drawerActive,
	          animating = _state.animating;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          navStyle = _props2.navStyle,
	          navClassName = _props2.navClassName,
	          component = _props2.component,
	          navItems = _props2.navItems,
	          header = _props2.header,
	          children = _props2.children,
	          inline = _props2.inline,
	          position = _props2.position,
	          overlay = _props2.overlay,
	          clickableDesktopOverlay = _props2.clickableDesktopOverlay,
	          lastChild = _props2.lastChild,
	          portal = _props2.portal,
	          overlayStyle = _props2.overlayStyle,
	          overlayClassName = _props2.overlayClassName,
	          propType = _props2.type,
	          propVisible = _props2.visible,
	          propRenderNode = _props2.renderNode,
	          propNavItemsId = _props2.navItemsId,
	          propZDepth = _props2.zDepth,
	          constantType = _props2.constantType,
	          defaultVisible = _props2.defaultVisible,
	          defaultMedia = _props2.defaultMedia,
	          mobileType = _props2.mobileType,
	          mobileMinWidth = _props2.mobileMinWidth,
	          tabletType = _props2.tabletType,
	          tabletMinWidth = _props2.tabletMinWidth,
	          desktopType = _props2.desktopType,
	          desktopMinWidth = _props2.desktopMinWidth,
	          transitionDuration = _props2.transitionDuration,
	          onMediaTypeChange = _props2.onMediaTypeChange,
	          onVisibilityChange = _props2.onVisibilityChange,
	          autoclose = _props2.autoclose,
	          autocloseAfterInk = _props2.autocloseAfterInk,
	          onVisibilityToggle = _props2.onVisibilityToggle,
	          closeOnNavItemClick = _props2.closeOnNavItemClick,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'clickableDesktopOverlay', 'lastChild', 'portal', 'overlayStyle', 'overlayClassName', 'type', 'visible', 'renderNode', 'navItemsId', 'zDepth', 'constantType', 'defaultVisible', 'defaultMedia', 'mobileType', 'mobileMinWidth', 'tabletType', 'tabletMinWidth', 'desktopType', 'desktopMinWidth', 'transitionDuration', 'onMediaTypeChange', 'onVisibilityChange', 'autoclose', 'autocloseAfterInk', 'onVisibilityToggle', 'closeOnNavItemClick']);
	
	      var _props3 = this.props,
	          navItemsId = _props3.navItemsId,
	          zDepth = _props3.zDepth;
	
	      if (!navItemsId && id) {
	        navItemsId = id + '-nav-items';
	      }
	
	      var desktop = this.state.desktop;
	
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var type = (0, _getField2.default)(this.props, this.state, 'type');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var mini = (0, _isType.isMini)(type);
	      var temporary = (0, _isType.isTemporary)(type);
	      var floating = _DrawerTypes2.default.FLOATING === type;
	      var permanent = (0, _isType.isPermanent)(type);
	
	      var Component = void 0;
	      if (component) {
	        Component = component;
	      } else if (navItems) {
	        Component = 'nav';
	      } else {
	        Component = 'aside';
	      }
	
	      var navigation = void 0;
	      if (navItems) {
	        navigation = _react2.default.createElement(
	          _List2.default,
	          {
	            ref: this._setNavigation,
	            key: 'navigation',
	            id: navItemsId,
	            style: navStyle,
	            className: (0, _classnames2.default)('md-list--drawer', {
	              'md-toolbar-relative': mini && !visible,
	              'md-background': floating
	            }, navClassName),
	            onClick: this._handleNavClick
	          },
	          navItems.map(_mapToListParts2.default)
	        );
	      }
	
	      if (typeof zDepth === 'undefined') {
	        zDepth = 1;
	        if (floating || inline) {
	          zDepth = 0;
	        } else if (!mini && temporary) {
	          zDepth = 5;
	        }
	      }
	
	      var overlayVisible = overlay;
	      if (typeof overlayVisible !== 'boolean') {
	        overlayVisible = temporary && !mini && (!desktop || clickableDesktopOverlay) && (animating || visible);
	      }
	
	      var drawer = _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          id: id,
	          key: 'drawer',
	          component: Component,
	          zDepth: zDepth,
	          raiseOnHover: false,
	          style: style,
	          className: (0, _classnames2.default)('md-drawer', (_cn = {}, _defineProperty(_cn, 'md-drawer--' + position, !inline), _defineProperty(_cn, 'md-drawer--fixed', !inline), _defineProperty(_cn, 'md-drawer--inline', inline), _defineProperty(_cn, 'md-drawer--active', mini || drawerActive), _defineProperty(_cn, 'md-drawer--mini', mini), _defineProperty(_cn, 'md-transition--deceleration', !mini && !permanent && visible), _defineProperty(_cn, 'md-transition--acceleration', !mini && !permanent && !visible), _defineProperty(_cn, 'md-background', inline || floating), _defineProperty(_cn, 'md-background--card', !floating && !inline), _cn), className)
	        }),
	        header,
	        navigation,
	        children,
	        _react2.default.createElement(_Overlay2.default, {
	          style: overlayStyle,
	          className: overlayClassName,
	          active: overlayActive,
	          onClick: this._closeDrawer,
	          visible: overlayVisible,
	          renderNode: renderNode
	        })
	      );
	
	      if (inline || permanent) {
	        return drawer;
	      } else if (!portal) {
	        return mini || animating || visible ? drawer : null;
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: animating || visible, renderNode: renderNode, lastChild: lastChild },
	        drawer
	      );
	    }
	  }]);
	
	  return Drawer;
	}(_react.PureComponent);
	
	Drawer.DrawerTypes = _DrawerTypes2.default;
	Drawer.propTypes = {
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `id` prop is
	   * defined, it will be defaulted to `${id}-nav-items`.
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * An optional component to render the drawer in. When this prop is undefined, the drawer
	   * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	
	  /**
	   * An optional list of navigation items to display in the drawer. This list can either contain
	   * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
	   * or `ListItem`.
	   *
	   * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
	   * passed to the `Divider` component.
	   * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
	   * be passed to the `Subheader` component.
	   * - To create a list item, just create an object with any normal `ListItem` props.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * Boolean if a temporary drawer should close when a nav item is clicked.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display. This _should_ normally be a toolbar.
	   */
	  header: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display after the `header` and `navItems`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The drawer type to use when the current device matches the mobile
	   * media query.
	   */
	  mobileType: _propTypes2.default.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The min-width to use for the mobile media query.
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the tablet
	   * media query.
	   */
	  tabletType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width to use for the tablet media query.
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The drawer type to use when the current device matches the desktop media
	   * query.
	   */
	  desktopType: oneOfDrawerTypes.isRequired,
	
	  /**
	   * The min-width for a desktop screen.
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional type to enforce across all media sizes. Since `mobile` devices are
	   * included, you are required to manually specify when the `type` should be `temporary`.
	   *
	   * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
	   * must be provided.
	   */
	  type: function type(props, propName, component) {
	    for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      others[_key - 3] = arguments[_key];
	    }
	
	    var type = props[propName];
	    if ((0, _isType.isTemporary)(type)) {
	      return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    }
	
	    var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	    if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
	      err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
	    }
	
	    return err;
	  },
	
	  /**
	   * An optional function to call when the drawer's type changes when the screen resizes.
	   * The callback will include the new `type` that should be used for the screen size,
	   * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * The default drawer type to display on initial render. The drawer will automatically
	   * adjust itself to the correct media once it has mounted. This prop is really only useful
	   * for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	  /**
	   * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
	   * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
	   * the device is not a desktop.
	   *
	   * Definining this variable as `true` or `false` will override any default behavior. This means that
	   * if this is enabled for a full-height drawer, an overlay will still be created.
	   */
	  overlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
	   * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
	   *
	   * This basically means that if you are using the default configuration, a mobile device's drawer
	   * will be hidden while tablets and desktops will be visible.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the drawer is visible. This will force the component to define the `onVisibilityChange`
	   * prop as well as manually updating the drawer's visibility.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer is changed. The function will
	   * be called with the new visibility state.
	   *
	   * ```js
	   * onVisibilityChange(!currentlyVisible);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
	   * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
	   *
	   * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
	   * children width on desktops.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
	   * is enabled, the `position` prop will not be used.
	   */
	  inline: _propTypes2.default.bool,
	
	  /**
	   * The `$md-drawer-transition-time` value from sass.
	   */
	  transitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
	   * the drawer will close when a user clicks anywhere on the page except in the drawer.
	   */
	  clickableDesktopOverlay: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `autoclose` feature should wait for the ink transition to finish before automatically
	   * closing the drawer. This will add a `300ms` delay. If this is `false`, there will only be a `17ms` delay.
	   *
	   * > The delay is required so that any event listeners will still be correctly invoked when an item is clicked.
	   */
	  autocloseAfterInk: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
	   * one of the temporary types.
	   *
	   * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
	   * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
	   */
	  constantType: _propTypes2.default.bool.isRequired,
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  zDepth: _propTypes2.default.number,
	
	  closeOnNavItemClick: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `autoclose` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead')
	};
	Drawer.defaultProps = {
	  defaultMedia: 'mobile',
	  mobileType: Drawer.DrawerTypes.TEMPORARY,
	  mobileMinWidth: _media.MOBILE_MIN_WIDTH,
	  tabletType: Drawer.DrawerTypes.PERSISTENT,
	  tabletMinWidth: _media.TABLET_MIN_WIDTH,
	  desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
	  desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	  position: 'left',
	  transitionDuration: 300,
	  autoclose: true,
	  clickableDesktopOverlay: true,
	  constantType: true
	};
	Drawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._updateType = function (props) {
	    var onMediaTypeChange = props.onMediaTypeChange,
	        overlay = props.overlay,
	        transitionDuration = props.transitionDuration;
	
	
	    var onVisibilityChange = props.onVisibilityToggle || props.onVisibilityChange;
	
	    var state = Drawer.getCurrentMedia(props);
	    var diffType = (0, _getField2.default)(props, _this2.state, 'type') !== state.type;
	    var diffMedia = state.mobile !== _this2.state.mobile || state.tablet !== _this2.state.tablet || state.desktop !== _this2.state.desktop;
	
	    if (onMediaTypeChange && (diffType || diffMedia)) {
	      onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
	    }
	
	    if (diffType) {
	      var visible = (0, _isType.isPermanent)(state.type);
	      if (_this2._initialFix) {
	        if (props.defaultVisible) {
	          visible = props.defaultVisible;
	        } else if (props.visible) {
	          visible = props.visible;
	        }
	      }
	
	      var prevVisible = (0, _getField2.default)(props, _this2.state, 'visible');
	      if (onVisibilityChange && visible !== prevVisible) {
	        onVisibilityChange(visible);
	      }
	
	      if (typeof props.visible === 'undefined') {
	        state.visible = visible;
	        _this2._animate(visible, state.type, transitionDuration, overlay, state.desktop);
	      }
	    } else if (_this2._initialFix && diffMedia) {
	      state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, _this2.state, 'visible');
	    }
	
	    if (typeof props.type !== 'undefined') {
	      var _state2 = state,
	          type = _state2.type,
	          realState = _objectWithoutProperties(_state2, ['type']); // eslint-disable-line no-unused-vars
	
	
	      state = realState;
	    }
	
	    _this2._initialFix = false;
	    _this2.setState(state);
	  };
	
	  this._updateMedia = function () {
	    _this2._updateType(_this2.props);
	  };
	
	  this._animate = function (visible, type, timeout, overlay, desktop) {
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    if (visible) {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({
	          overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
	          drawerActive: true,
	          animating: true
	        });
	      }, _CSSTransitionGroupTick2.default);
	    } else {
	      _this2._timeout = setTimeout(function () {
	        _this2._timeout = null;
	
	        _this2.setState({ animating: false });
	      }, timeout);
	      _this2.setState({ animating: true, overlayActive: false, drawerActive: false });
	    }
	  };
	
	  this._setNavigation = function (navigation) {
	    _this2._navigation = (0, _reactDom.findDOMNode)(navigation);
	  };
	
	  this._handleNavClick = function (e) {
	    var _props4 = _this2.props,
	        closeOnNavItemClick = _props4.closeOnNavItemClick,
	        autoclose = _props4.autoclose,
	        autocloseAfterInk = _props4.autocloseAfterInk;
	
	    var enabled = typeof closeOnNavItemClick !== 'undefined' ? closeOnNavItemClick : autoclose;
	    if (!enabled || !(0, _isType.isTemporary)((0, _getField2.default)(_this2.props, _this2.state, 'type'))) {
	      return;
	    }
	
	    var target = e.target;
	
	    while (target && _this2._navigation.contains(target)) {
	      if (target.classList.contains('md-list-tile')) {
	        // Clicked a nav item that has a nested list
	        if (target.getAttribute('aria-expanded') !== null) {
	          return;
	        }
	
	        _this2._closeTimeout = setTimeout(function () {
	          _this2._closeTimeout = null;
	
	          _this2._closeDrawer(e);
	        }, autocloseAfterInk ? 300 : _CSSTransitionGroupTick2.default);
	        return;
	      }
	
	      target = target.parentNode;
	    }
	  };
	
	  this._closeDrawer = function () {
	    var _props5 = _this2.props,
	        onVisibilityChange = _props5.onVisibilityChange,
	        onVisibilityToggle = _props5.onVisibilityToggle,
	        transitionDuration = _props5.transitionDuration,
	        overlay = _props5.overlay;
	
	    var callback = onVisibilityToggle || onVisibilityChange;
	    if (callback) {
	      callback(false);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: false });
	      _this2._animate(false, (0, _getField2.default)(_this2.props, _this2.state, 'type'), transitionDuration, overlay, _this2.state.desktop);
	    }
	  };
	};
	
	exports.default = Drawer;
	//# sourceMappingURL=Drawer.js.map

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Drawers/DrawerTypes */
	
	/**
	 * An enum for all the different type of drawers.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var DrawerTypes = {
	  // Permanent drawers
	  /**
	   * This is the default drawer type. It will always be on the screen and takes
	   * up the entire height. This is very helpful for main navigation on desktops
	   * when you do not need an expandable workspace.
	   */
	  FULL_HEIGHT: 'full-height',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar.
	   */
	  CLIPPED: 'clipped',
	
	  /**
	   * This drawer type will always be on the screen, but it will appear under the
	   * main toolbar and have a transparent background. This is useful if you want
	   * a persistent drawer on desktop screens, but do not want the main focus to be
	   * the drawer.
	   */
	  FLOATING: 'floating',
	
	  // Persistent drawers
	  /**
	   * A persistent drawer changes between being hidden and being fixed on the page like
	   * a permanent drawer. When it is visible, it will take up the same amount of room
	   * as a permanent drawer, and will not go away until closed.
	   *
	   * This drawer type is helpful when you need to have a dynamic workspace size.
	   */
	  PERSISTENT: 'persistent',
	
	  /**
	   * This is a modification of the persistent drawer. It will behave as the persistent drawer
	   * but it will always have a "mini" drawer visible. This is helpful when you want to have
	   * a dynamic workspace size and keep certain actions available at all times.
	   */
	  PERSISTENT_MINI: 'persistent-mini',
	
	  // Temporary
	  /**
	   * A temporary drawer will not be visible by default. When it is visible, it will overlay
	   * the page to get the main focus on the drawer. When the user touches the overlay or
	   * one of the navigation items, the drawer will be closed. The overlay can be disabled on
	   * desktop and tablets.
	   */
	  TEMPORARY: 'temporary',
	
	  /**
	   * This is a modification of the temporary drawer. It will behave like a temporary drawer,
	   * but it will always have a "mini" drawer visible. Just like the `PERSISTENT_MINI` drawer
	   * type, this is useful when certain actions should be available at all times but additional
	   * actions are available when the drawer is visible.
	   */
	  TEMPORARY_MINI: 'temporary-mini'
	};
	
	exports.default = DrawerTypes;
	//# sourceMappingURL=DrawerTypes.js.map

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Portal = __webpack_require__(97);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_PureComponent) {
	  _inherits(Overlay, _PureComponent);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // Always want the overlay to render in a separate subtree until 1.1.0
	      return { isInPortal: false };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          visible = _props.visible,
	          renderNode = _props.renderNode,
	          onClick = _props.onClick,
	          style = _props.style,
	          className = _props.className;
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        { visible: visible, renderNode: renderNode },
	        _react2.default.createElement('div', {
	          style: style,
	          className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
	            'md-overlay--active': active
	          }, className),
	          onClick: onClick
	        })
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.PureComponent);
	
	Overlay.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  visible: _propTypes2.default.bool.isRequired,
	  renderNode: _propTypes2.default.object,
	  onClick: _propTypes2.default.func
	};
	Overlay.childContextTypes = {
	  isInPortal: _propTypes2.default.bool
	};
	exports.default = Overlay;
	//# sourceMappingURL=Overlay.js.map

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isTemporary = isTemporary;
	exports.isPersistent = isPersistent;
	exports.isPermanent = isPermanent;
	exports.isMini = isMini;
	
	var _DrawerTypes = __webpack_require__(214);
	
	var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
	    CLIPPED = _DrawerTypes2.default.CLIPPED,
	    FLOATING = _DrawerTypes2.default.FLOATING,
	    PERSISTENT = _DrawerTypes2.default.PERSISTENT,
	    PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
	    TEMPORARY = _DrawerTypes2.default.TEMPORARY,
	    TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
	function isTemporary(type) {
	  return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	
	function isPersistent(type) {
	  return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
	}
	
	function isPermanent(type) {
	  return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
	}
	
	function isMini(type) {
	  return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
	}
	//# sourceMappingURL=isType.js.map

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keyCodes = __webpack_require__(43);
	
	var _handleKeyboardAccessibility = __webpack_require__(231);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `AccessibleFakeButton` is a generic component that can be used to render
	 * a `div` or any other non `button` components as a button. This should not be
	 * used often.
	 *
	 * The `AccessibleFakeButton` allows the user to tab focus the element, use the
	 * space or enter key to trigger the `onClick` event, and toggles the `aria-pressed`
	 * attribute.
	 */
	var AccessibleFakeButton = function (_PureComponent) {
	  _inherits(AccessibleFakeButton, _PureComponent);
	
	  function AccessibleFakeButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AccessibleFakeButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccessibleFakeButton.__proto__ || Object.getPrototypeOf(AccessibleFakeButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { pressed: false, tabFocused: false }, _this.focus = function () {
	      if (_this._node) {
	        _this._node.focus();
	      }
	    }, _this.blur = function () {
	      if (_this._node) {
	        _this._node.blur();
	      }
	    }, _this._setNode = function (node) {
	      if (node) {
	        _this._node = (0, _reactDom.findDOMNode)(node);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      _this._node.focus();
	      _this.setState({ pressed: !_this.state.pressed });
	    }, _this._handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onKeyDown = _this$props.onKeyDown,
	          listenToEnter = _this$props.listenToEnter,
	          listenToSpace = _this$props.listenToSpace;
	
	      if (disabled) {
	        return;
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, listenToEnter, listenToSpace);
	    }, _this._handleKeyUp = function (e) {
	      var _this$props2 = _this.props,
	          onKeyUp = _this$props2.onKeyUp,
	          onTabFocus = _this$props2.onTabFocus;
	
	      if (onKeyUp) {
	        onKeyUp(e);
	      }
	
	      if ((e.which || e.keyCode) === _keyCodes.TAB) {
	        if (onTabFocus) {
	          onTabFocus(e);
	        }
	
	        _this.setState({ tabFocused: true });
	      }
	    }, _this._handleBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	
	      if (_this.state.tabFocused) {
	        _this.setState({ tabFocused: false });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Focuses the button.
	   */
	
	
	  /**
	   * Blurs the button.
	   */
	
	
	  _createClass(AccessibleFakeButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          children = _props.children,
	          className = _props.className,
	          tabbedClassName = _props.tabbedClassName,
	          disabled = _props.disabled,
	          tabIndex = _props.tabIndex,
	          ink = _props.ink,
	          noFocusOutline = _props.noFocusOutline,
	          onBlur = _props.onBlur,
	          onClick = _props.onClick,
	          onKeyUp = _props.onKeyUp,
	          onKeyDown = _props.onKeyDown,
	          onTabFocus = _props.onTabFocus,
	          listenToEnter = _props.listenToEnter,
	          listenToSpace = _props.listenToSpace,
	          props = _objectWithoutProperties(_props, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink', 'noFocusOutline', 'onBlur', 'onClick', 'onKeyUp', 'onKeyDown', 'onTabFocus', 'listenToEnter', 'listenToSpace']);
	
	      var childElements = children;
	      if (ink) {
	        childElements = _react.Children.toArray(children);
	        childElements.unshift(ink);
	      }
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          ref: this._setNode,
	          className: (0, _classnames2.default)('md-fake-btn', _defineProperty({
	            'md-pointer--hover': !disabled,
	            'md-fake-btn--no-outline': noFocusOutline
	          }, tabbedClassName, tabbedClassName && this.state.tabFocused), className),
	          disabled: disabled,
	          tabIndex: disabled ? null : tabIndex,
	          onBlur: this._handleBlur,
	          onClick: this._handleClick,
	          onKeyUp: this._handleKeyUp,
	          onKeyDown: this._handleKeyDown,
	          'aria-pressed': this.state.pressed
	        }),
	        childElements
	      );
	    }
	  }]);
	
	  return AccessibleFakeButton;
	}(_react.PureComponent);
	
	AccessibleFakeButton.propTypes = {
	  /**
	   * An optional style to apply.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call only when the button has been focused with the tab key.
	   */
	  tabbedClassName: _propTypes2.default.string,
	
	  /**
	   * Any children to display in the Accessible Fake Button.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional onClick function to call when the user clicks the
	   * button or presses space || enter.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyDown function to call.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional onBlur function to call.
	   */
	  onBlur: _propTypes2.default.func,
	
	  /**
	   * An optional onKeyUp function to call.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the element is focused with the tab key.
	   */
	  onTabFocus: _propTypes2.default.func,
	
	  /**
	   * The component to render the Fake button as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the default outline should be removed the when the fake button has been focused.
	   *
	   * @see {@link #tabbedClassName}
	   */
	  noFocusOutline: _propTypes2.default.bool,
	
	  /**
	   * The tab index to use for the Fake button so it is keyboard focusable.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * Boolean if the Button is disabled. This will prevent tab focus.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * The role for the accessible fake button. It is recommended to keep it
	   * the default of `button` unless you are rendering it as an `a` tag.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * The ink when coming from the AccessibleFakeInkedButton
	   * @access private
	   */
	  ink: _propTypes2.default.node,
	
	  /**
	   * Boolean if the spacebar should be used to trigger the click event. This _should_ be `true`
	   * is almost all cases.
	   */
	  listenToSpace: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the enter key should be used to trigger the click event. This _should_ be `true`
	   * in most cases. By default, the param will be ignored if the `role` attribute is for a `checkbox`
	   * or `radio`. When it is a checkbox or radio, it will attempt to submit the form on the enter
	   * keypress instead like the native elements.
	   */
	  listenToEnter: _propTypes2.default.bool
	};
	AccessibleFakeButton.defaultProps = {
	  component: 'div',
	  tabIndex: 0,
	  role: 'button',
	  noFocusOutline: true,
	  listenToEnter: true,
	  listenToSpace: true
	};
	exports.default = AccessibleFakeButton;
	//# sourceMappingURL=AccessibleFakeButton.js.map

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccessibleFakeButton = __webpack_require__(560);
	
	var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	var _injectInk = __webpack_require__(223);
	
	var _injectInk2 = _interopRequireDefault(_injectInk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);
	//# sourceMappingURL=AccessibleFakeInkedButton.js.map

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/HorizontalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var HorizontalAnchors = {
	  /**
	   * Positions the layover to the outside left on the toggle component
	   * so that it does not overlap.
	   */
	  LEFT: 'left',
	
	  /**
	   * Positions the layover to the inner left of the toggle component so
	   * that it will overlap.
	   */
	  INNER_LEFT: 'inner left',
	
	  /**
	   * Positions the layover so that it overlaps the toggle component
	   * by positioning itself in the cetner of the toggle component's width.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it does not overlap.
	   */
	  RIGHT: 'right',
	
	  /**
	   * Positions the layover to the outside right on the toggle component
	   * so that it will overlap.
	   */
	  INNER_RIGHT: 'inner right'
	};
	
	exports.default = HorizontalAnchors;
	//# sourceMappingURL=HorizontalAnchors.js.map

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSTransitionGroup = __webpack_require__(108);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _handleWindowClickListeners = __webpack_require__(580);
	
	var _handleWindowClickListeners2 = _interopRequireDefault(_handleWindowClickListeners);
	
	var _getSelectedTextPosition = __webpack_require__(587);
	
	var _getSelectedTextPosition2 = _interopRequireDefault(_getSelectedTextPosition);
	
	var _getScroll = __webpack_require__(586);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _viewport = __webpack_require__(590);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _isOutOfBounds = __webpack_require__(589);
	
	var _isOutOfBounds2 = _interopRequireDefault(_isOutOfBounds);
	
	var _anchorShape = __webpack_require__(146);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(98);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(222);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _HorizontalAnchors = __webpack_require__(218);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(221);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	var _Positions = __webpack_require__(220);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	var _ResizeObserver = __webpack_require__(562);
	
	var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Layover component is used to keep a component fixed to another component
	 * while the page is scrolling or a container is scrolling. When the fixed component
	 * is considered out of view, it will be closed.
	 *
	 * > NOTE: Don't look at source code. Plz.
	 */
	var Layover = function (_PureComponent) {
	  _inherits(Layover, _PureComponent);
	
	  function Layover(props) {
	    _classCallCheck(this, Layover);
	
	    var _this = _possibleConstructorReturn(this, (Layover.__proto__ || Object.getPrototypeOf(Layover)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var child = _react2.default.Children.only(props.children);
	    _this.state = {
	      below: false,
	      right: false,
	      styles: child.props.style
	    };
	
	    _this._lastXFix = null;
	    _this._lastYFix = null;
	    _this._initialX = null;
	    _this._initialY = null;
	    _this._initialTop = null;
	    _this._initialLeft = null;
	    _this._child = null;
	    _this._toggle = null;
	    return _this;
	  }
	
	  _createClass(Layover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (false) {
	        window.addEventListener('load', function () {
	          _this2._setContainer(_this2._container);
	        });
	      }
	
	      var _props = this.props,
	          visible = _props.visible,
	          fixedTo = _props.fixedTo,
	          sameWidth = _props.sameWidth,
	          centered = _props.centered,
	          simplified = _props.simplified;
	
	      var anchor = this._getAnchor(this.props);
	      if (visible) {
	        (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, true);
	
	        // Don't worry about any of the other logic for a "simple" layover
	        if (simplified) {
	          return;
	        }
	
	        var rect = this._contextRect || this._toggle.getBoundingClientRect();
	        if (this._dialog) {
	          this._manageFixedToListener(this._dialog, true);
	        } else if (!this._inFixed) {
	          this._manageFixedToListener(fixedTo, true);
	        }
	
	        this._init(fixedTo, anchor, sameWidth, centered, rect);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var fixedTo = nextProps.fixedTo,
	          visible = nextProps.visible,
	          children = nextProps.children,
	          sameWidth = nextProps.sameWidth,
	          centered = nextProps.centered,
	          simplified = nextProps.simplified;
	
	      if (simplified) {
	        if (this.props.simplified !== simplified) {
	          this._reset();
	        }
	        return;
	      }
	
	      var anchor = this._getAnchor(nextProps);
	      var visibileDiff = visible !== this.props.visible;
	      var childStyle = _react2.default.Children.only(children).props.style;
	
	      if (visibileDiff) {
	        if (!visible) {
	          this._reset();
	        } else {
	          // Initialize the layover logic
	          var rect = this._contextRect || this._toggle.getBoundingClientRect();
	          if (this._dialog) {
	            this._manageFixedToListener(this._dialog, true);
	          } else if (!this._inFixed) {
	            this._manageFixedToListener(fixedTo, true);
	          }
	
	          this._init(fixedTo, anchor, sameWidth, centered, rect);
	        }
	      } else if (fixedTo !== this.props.fixedTo && visible) {
	        // swap the fixedTo listeners
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageFixedToListener(fixedTo, true);
	      } else if (childStyle !== _react2.default.Children.only(this.props.children).props.style) {
	        // Re-merge styles... This is only required if all the others fail since all the other
	        // logic always merges styles with the children styles
	        this.setState({ styles: _extends({}, this.state.styles, childStyle) });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          visible = _props2.visible,
	          closeOnOutsideClick = _props2.closeOnOutsideClick;
	
	      var enabled = visible && closeOnOutsideClick;
	      var prevEnabled = prevProps.visible && prevProps.closeOnOutsideClick;
	      if (enabled !== prevEnabled) {
	        if (this._clickTimeout) {
	          clearTimeout(this._clickTimeout);
	          this._clickTimeout = null;
	        }
	
	        // This is really an arbitrary timeout time, but firefox needs to have a timeout
	        // so the context menu doesn't close automatically due to an "outside click" being
	        // triggered
	        this._clickTimeout = setTimeout(function () {
	          _this3._clickTimeout = null;
	          (0, _handleWindowClickListeners2.default)(_this3._handleOutsideClick, enabled);
	        }, enabled ? 300 : 0);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._clickTimeout) {
	        clearTimeout(this._clickTimeout);
	        this._clickTimeout = null;
	      }
	      (0, _handleWindowClickListeners2.default)(this._handleOutsideClick, false);
	
	      if (!this.props.simplified) {
	        this._manageFixedToListener(this.props.fixedTo, false);
	        this._manageWindowResizeListener(false);
	      }
	    }
	  }, {
	    key: '_getAnchor',
	    value: function _getAnchor(_ref) {
	      var anchor = _ref.anchor,
	          belowAnchor = _ref.belowAnchor,
	          animationPosition = _ref.animationPosition;
	
	      return animationPosition === Layover.Positions.BELOW && belowAnchor || anchor;
	    }
	
	    /**
	     * Whew. Ok. So since the fixedTo prop can either be two elements or a single item,
	     * this utility function is used to add/remove the scrolling event listeners for
	     * this prop.
	     *
	     * When the fixedTo prop has a horizontal and/or vertical attribute, the `window`
	     * will be the fallback option. If both the horizontal and vertical attributes are
	     * defined, the `window` still needs to have a scroll listener to make sure it
	     * doesn't go off screen.
	     */
	
	
	    /**
	     * This is just a simple utility function to merge the existing state styles,
	     * any new styles, and the children's styles (with most precedence).
	     */
	
	
	    /**
	     * This initializes the popover with the default styles, and the initial bookkeeping
	     * variables to update while it is open.
	     */
	
	
	    /**
	     * Attempts to fix the child by setting it's location ONLY for the entire
	     * page viewport. I didn't bother attempting to fix it for additional fixedTo
	     * stuff.
	     */
	
	
	    /**
	     * When the child is initially mounted, it will update the styles for centering
	     * the element (if enabled) and then attempt to fix any viewport issues.
	     */
	
	
	    /**
	     * This is the meat of the stuff. Do lots of viewport / container checks to make sure
	     * the element should still be visible. If it is still visible, it will update its
	     * x and y position for the new scroll position.
	     */
	
	
	    /**
	     * Attempts to fix a viewport problem by swapping the positioning. This only does
	     * vertical switching right now.
	     *
	     * @param {Object} vp - The result of the viewport function
	     * @return {boolean} true if the fix was able to be done and successful.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          block = _props3.block,
	          toggle = _props3.toggle,
	          visible = _props3.visible,
	          children = _props3.children,
	          fullWidth = _props3.fullWidth,
	          animationPosition = _props3.animationPosition,
	          simplified = _props3.simplified,
	          fillViewportWidth = _props3.fillViewportWidth,
	          fillViewportHeight = _props3.fillViewportHeight,
	          anchor = _props3.anchor,
	          belowAnchor = _props3.belowAnchor,
	          onClose = _props3.onClose,
	          repositionOnScroll = _props3.repositionOnScroll,
	          repositionOnResize = _props3.repositionOnResize,
	          sameWidth = _props3.sameWidth,
	          centered = _props3.centered,
	          fixedTo = _props3.fixedTo,
	          toggleQuery = _props3.toggleQuery,
	          yThreshold = _props3.yThreshold,
	          xThreshold = _props3.xThreshold,
	          onContextMenu = _props3.onContextMenu,
	          preventContextMenu = _props3.preventContextMenu,
	          closeOnOutsideClick = _props3.closeOnOutsideClick,
	          minLeft = _props3.minLeft,
	          minRight = _props3.minRight,
	          minBottom = _props3.minBottom,
	          props = _objectWithoutProperties(_props3, ['className', 'block', 'toggle', 'visible', 'children', 'fullWidth', 'animationPosition', 'simplified', 'fillViewportWidth', 'fillViewportHeight', 'anchor', 'belowAnchor', 'onClose', 'repositionOnScroll', 'repositionOnResize', 'sameWidth', 'centered', 'fixedTo', 'toggleQuery', 'yThreshold', 'xThreshold', 'onContextMenu', 'preventContextMenu', 'closeOnOutsideClick', 'minLeft', 'minRight', 'minBottom']);
	
	      var child = void 0;
	      var childId = void 0;
	      if (visible) {
	        child = _react2.default.Children.only(children);
	        if (child.props.id) {
	          childId = child.props.id;
	        } else if (props.id) {
	          childId = props.id + '-layover';
	        }
	
	        child = _react2.default.cloneElement(children, {
	          ref: this._fixateChild,
	          id: childId,
	          style: simplified ? child.props.style : this.state.styles,
	          className: (0, _classnames2.default)('md-layover-child md-layover-child--' + animationPosition, {
	            'md-layover-child--simplified': simplified
	          }, child.props.className)
	        });
	      }
	
	      var observer = null;
	      if (!simplified && !fillViewportWidth && !fillViewportHeight) {
	        observer = _react2.default.createElement(_ResizeObserver2.default, {
	          watchWidth: !fillViewportWidth,
	          watchHeight: !fillViewportHeight,
	          target: this._child,
	          onResize: this._handleResize
	        });
	      }
	
	      return _react2.default.createElement(
	        _CSSTransitionGroup2.default,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-layover', {
	            'md-layover--simplified': simplified,
	            'md-inline-block': !block && !fullWidth,
	            'md-full-width': fullWidth
	          }, className),
	          ref: this._setContainer,
	          'aria-haspopup': true,
	          'aria-owns': childId,
	          'aria-expanded': visible,
	          transitionEnter: props.transitionEnterTimeout !== 0,
	          transitionLeave: props.transitionLeaveTimeout !== 0,
	          onContextMenu: this._handleContextMenu
	        }),
	        observer,
	        toggle,
	        child
	      );
	    }
	  }]);
	
	  return Layover;
	}(_react.PureComponent);
	
	Layover.HorizontalAnchors = _HorizontalAnchors2.default;
	Layover.VerticalAnchors = _VerticalAnchors2.default;
	Layover.Positions = _Positions2.default;
	Layover.propTypes = {
	  /**
	   * A id to give the layover itself. This is generally recommended for accessibility. If the
	   * child does not have an id, the child will automatically be updated to be `${id}-layover`.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the layover.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the layover.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the layover's child is currently visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This should either be a single element or two elements that the layover recalculates
	   * its fixed position when scrolling for horizontal and vertical.
	   *
	   * When it is a single element, it will recalculate for both horizontal and vertical
	   * scrolling. Otherwise, you can specify the element for horizontal scrolling and a
	   * separate element for vertical scrolling. If one is omitted, it will default to `window`.
	   *
	   * If the component is no longer considered to be in view after scrolling, the `onClose`
	   * prop will be called.
	   */
	  fixedTo: _fixedToShape2.default.isRequired,
	
	  /**
	   * The renderable item that causes the Layover to become visible. This _should_
	   * most likely be an `element` or `arrayOf(element)`, but anything is allowed.
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * Since the `toggle` prop can be anything, I need a way to be able to find an
	   * element to base all the calculations on. This can either be a string that
	   * gets passed to `layover.querySelector`, a DOM Element, or a function that
	   * returns a DOM Element.
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]).isRequired,
	
	  /**
	   * A single child that should be fixed to the toggle element.
	   */
	  children: _propTypes2.default.element.isRequired,
	
	  /**
	   * Boolean if the Layover should be displayed as a block instead of as an inline block.
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `children` should be centered horizontally and vertically while keeping
	   * its height in mind as well. This is *only* valid if both the x and y `anchor` targets
	   * are `CENTER`.
	   */
	  centered: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should gain the `md-full-width` class name.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width of the children should be updated automatically to be the width
	   * of the toggle element.
	   */
	  sameWidth: _propTypes2.default.bool,
	
	  /**
	   * The minimum value the `left` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the left of the page. It can also be used to make
	   * full screen layovers on devices when when the `fillViewportWidth` prop is enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minRight}
	   * @see {@link #fillViewportWidth}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value the `right` style can be for the child component. This is really just used
	   * to make sure it doesn't scroll off the right of the page when the `fillViewportWidth` prop is
	   * enabled.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #fillViewportWidth}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * The minimum value that can be used for the `bottom` prop when the `fillViewportHeight` prop is enabled.
	   * It is generally recommended to keep this value at `0` to keep it stretched to the bottom of the viewport
	   * or setting it to a small positive number to add some padding.
	   *
	   * This can either be a number of pixels or a string for percentages. If this value is a string
	   * **it will always be used over the calculated values** so it is preferred to use a number.
	   *
	   * @see {@link #fillViewportHeight}
	   */
	  minBottom: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the layover should make the child fill the entire viewport's width. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   left: this.props.minLeft,
	   *   right: this.props.minRight,
	   * };
	   * ```
	   *
	   * If you add any additional constraints such as `width` or `max-width`, it will not span the entire viewport's
	   * width. This prop should generally really only be used on mobile devices. Using this prop along with
	   * `fillViewportHeight` for Autocompletes can create great Android mobile searches. See the `fillViewportHeight`
	   * for more information about why it is *only Android*.
	   *
	   * @see {@link #minLeft}
	   * @see {@link #minRight}
	   * @see {@link #fillViewportHeight}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should fill the height of the viewport from the current calculated `top`. This will just
	   * style the child element with:
	   *
	   * ```js
	   * childStyle = {
	   *   top: currentCalculatedTop,
	   *   bottom: this.props.minBottom,
	   *   maxHeight: 'none',
	   * };
	   * ```
	   *
	   * This is *super* nice on Android devices since it will allow you to create nice toolbar search autocompletes
	   * in your app and the list of items will grow until it reaches the soft keyboard. It isn't as nice on iOS since
	   * iOS does not subtract the soft keyboard from the viewport's size so the list will still extend to the bottom
	   * of the page.
	   *
	   * @see {@link #minBottom}
	   * @see {@link #fillViewportWidth}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  /**
	   * A function used to hide the visibility of the children when the children are no longer
	   * visible or an element outside of the layover is clicked.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * The component to render the Layover as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The transition name to use for the children appearing/disappearing.
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition duration for the enter animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionEnterTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * The transition duration for the leave animation. The animation can be disabled by setting
	   * this value to 0.
	   */
	  transitionLeaveTimeout: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `children`'s width.
	   */
	  xThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * This is a threshold that is used to calculate if the `children` is still in
	   * view by applying this multiplier to the `toggle`'s height.
	   */
	  yThreshold: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `children` should be hidden when an element outside
	   * of the `Layout` component has been clicked.
	   */
	  closeOnOutsideClick: _propTypes2.default.bool.isRequired,
	
	  /**
	   * This is how the children get "anchored" to the `toggle` element and how the
	   * auto-fix attempts will be made. Right now, the auto fixes will only be handled
	   * on viewport boundaries instead of `fixedTo` boundaries. It was too hard for
	   * first attempt.
	   *
	   * The general behavior will be that an equal-opposite of an anchor will be chosen
	   * when that direction is out of viewport. So for example, the children are out
	   * of viewport for the right of the screen, and the `anchor.x` value is
	   * `Layover.HorizontalPositions.RIGHT`, the children will be swapped to be the `LEFT`
	   * of the `toggle` component now.
	   *
	   * So a full list:
	   * - `LEFT` / `RIGHT`
	   * - `INNER_LEFT` / `INNER_RIGHT`
	   * - `TOP` / `BOTTOM`
	   *
	   * The `CENTER` and `OVERLAP` positions can not be automatically adjusted.
	   *
	   * > To be safe, you should use the enum values for the `x` and `y` values.
	   * @see {@link #VerticalAnchors}
	   * @see {@link #HorizontalAnchors}
	   */
	  anchor: _anchorShape2.default.isRequired,
	
	  /**
	   * This is how the children get "anchored" when the `animationPositions` is set to `Layover.Positions.BELOW`.
	   * Set this to `null` to continue using the base `anchor` prop instead of switching to this anchor.
	   *
	   * @see {@link #anchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the position that the children should animate from. It directly ties into
	   * the `$md-layover-child-positions` Sass variable.
	   */
	  animationPosition: _positionShape2.default.isRequired,
	
	  /**
	   * If you would like the layover to interact as a context menu, provide this prop. It will
	   * make the children appear relative to the context menu origin automatically.
	   *
	   * @see {@link #preventContextMenu}
	   */
	  onContextMenu: _propTypes2.default.func,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link #onContextMenu}
	   */
	  preventContextMenu: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should attempt to automatically adjust the position of the element to
	   * keep it within the viewport. If this value is set to `false`, the `onClose` prop will be called
	   * instead.
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the layover should become "simplified". This basically disables all the logic for
	   * keeping the child within the viewport and allows you to manage all the positioning via CSS.
	   *
	   * When this is enabled, it updates the `Layover` to have `position: relative` while the child will
	   * have `position: absolute` which will allow for simple `top`, `right`, `bottom`, and/or `left` CSS
	   * to position as wanted.
	   *
	   * This is really only helpful in cases where the layover can't calculate things correctly due to
	   * being in fixed containers somewhere in the page or some other weird stuff. Hopefully this won't
	   * really need to be used much.
	   */
	  simplified: _propTypes2.default.bool
	};
	Layover.defaultProps = {
	  anchor: {
	    x: Layover.HorizontalAnchors.INNER_LEFT,
	    y: Layover.VerticalAnchors.OVERLAP
	  },
	  belowAnchor: {
	    x: Layover.HorizontalAnchors.CENTER,
	    y: Layover.VerticalAnchors.BOTTOM
	  },
	  animationPosition: Layover.Positions.BELOW,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  component: 'div',
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  toggleQuery: '.md-text-field-container,button,*[role="button"],*[role="listbox"]',
	  transitionName: 'md-layover',
	  transitionEnterTimeout: 200,
	  transitionLeaveTimeout: 200,
	  yThreshold: 0.38,
	  xThreshold: 0.38,
	  closeOnOutsideClick: true,
	  preventContextMenu: true,
	  simplified: false,
	  minLeft: 0,
	  minRight: 0,
	  minBottom: 0,
	  fillViewportWidth: false,
	  fillViewportHeight: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this._isCenteredDialog = function () {
	    return _this4._dialog && _this4._dialog.classList.contains('md-dialog--centered');
	  };
	
	  this._createStyles = function (anchor, centered, child, rect) {
	    var x = anchor.x,
	        y = anchor.y;
	    var offsetWidth = child.offsetWidth,
	        offsetHeight = child.offsetHeight;
	
	
	    var left = void 0;
	    var top = void 0;
	    if (x === _HorizontalAnchors2.default.CENTER) {
	      left = rect.left + rect.width / 2 - offsetWidth / 2;
	    } else if (x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      left = rect.right - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.LEFT) {
	      left = rect.left - offsetWidth;
	    } else if (x === _HorizontalAnchors2.default.RIGHT) {
	      left = rect.right;
	    }
	
	    if (centered && x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top - offsetHeight / 2 + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.TOP) {
	      top = rect.top - offsetHeight;
	    } else if (y === _VerticalAnchors2.default.CENTER) {
	      top = rect.top + rect.height / 2;
	    } else if (y === _VerticalAnchors2.default.BOTTOM) {
	      top = rect.bottom;
	    }
	
	    if (_this4._isCenteredDialog()) {
	      var dialogRect = _this4._dialog.getBoundingClientRect();
	      left -= dialogRect.left;
	      top -= dialogRect.top;
	    }
	
	    var style = {};
	    if (top) {
	      style.top = top;
	    }
	
	    if (left) {
	      style.left = left;
	    }
	
	    return style;
	  };
	
	  this._manageFixedToListener = function (fixedTo, add) {
	    var listener = (add ? 'add' : 'remove') + 'EventListener';
	    if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      var x = fixedTo.x,
	          y = fixedTo.y;
	
	      if (x) {
	        x[listener]('scroll', _this4._handleScroll);
	      } else {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y) {
	        y[listener]('scroll', _this4._handleScroll);
	      } else if (!x) {
	        // Only add the window event listener once
	        window[listener]('scroll', _this4._handleScroll);
	      }
	
	      if (y && y !== window && x && x !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    } else {
	      fixedTo[listener]('scroll', _this4._handleScroll);
	
	      if (fixedTo !== window) {
	        window[listener]('scroll', _this4._handleScroll);
	      }
	    }
	  };
	
	  this._manageWindowResizeListener = function (enabled) {
	    if (_this4._windowResizeTimeout) {
	      clearTimeout(_this4._windowResizeTimeout);
	      _this4._windowResizeTimeout = null;
	    }
	
	    if (enabled) {
	      // add a 2 second delay before watching resize events since Android soft keyboards trigger a resize event.
	      _this4._windowResizeTimeout = setTimeout(function () {
	        _this4._windowResizeTimeout = null;
	        window.addEventListener('resize', _this4._handleWindowResize);
	      }, 2000);
	    } else {
	      window.removeEventListener('resize', _this4._handleWindowResize);
	    }
	  };
	
	  this._mergeStyles = function (style) {
	    var _props4 = _this4.props,
	        minLeft = _props4.minLeft,
	        minRight = _props4.minRight,
	        minBottom = _props4.minBottom,
	        fillViewportWidth = _props4.fillViewportWidth,
	        fillViewportHeight = _props4.fillViewportHeight;
	
	    if (fillViewportWidth) {
	      style.left = minLeft;
	      style.right = minRight;
	    } else {
	      if (style.left) {
	        style.left = Math.max(minLeft, style.left);
	      }
	
	      if (style.right) {
	        style.right = Math.max(minRight, style.right);
	      }
	    }
	
	    if (fillViewportHeight) {
	      style.bottom = minBottom;
	      style.maxHeight = 'none';
	    } else {
	      // These styles are only created when filling the viewport height, so clear
	      // them out again
	      style.bottom = null;
	      style.maxHeight = null;
	    }
	
	    return _extends({}, _this4.state.styles, style, _react2.default.Children.only(_this4.props.children).props.style);
	  };
	
	  this._init = function (fixedTo, anchor, sameWidth, centered, rect) {
	    if (_this4._child) {
	      // The init function can be called again if the user quickly toggles the layover. If that
	      // is the case, we want the styles that were set after the _positionChild _attemptFix.
	      return;
	    }
	
	    var height = rect.height,
	        width = rect.width;
	    var top = rect.top,
	        left = rect.left,
	        right = rect.right;
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	
	      if (_this4._isCenteredDialog()) {
	        var dialogRect = _this4._dialog.getBoundingClientRect();
	        left -= dialogRect.left;
	        top -= dialogRect.top;
	        right -= dialogRect.right;
	      }
	    } else if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll = (0, _getScroll2.default)(fixedTo);
	      x = _scroll.x;
	      y = _scroll.y;
	    }
	
	    _this4._initialX = x;
	    _this4._initialY = y;
	    _this4._initialLeft = left;
	    _this4._initialTop = top;
	
	    if (anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._initialLeft = left + width;
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT) {
	      _this4._initialLeft = right;
	    }
	
	    if (!centered) {
	      _this4._lastYFix = anchor.y === _VerticalAnchors2.default.TOP ? 'bottom' : 'top';
	    } else {
	      // Centered is not fixable
	      _this4._lastYFix = null;
	    }
	    if (anchor.x === _HorizontalAnchors2.default.LEFT || anchor.x === _HorizontalAnchors2.default.INNER_LEFT) {
	      _this4._lastXFix = 'right';
	    } else if (anchor.x === _HorizontalAnchors2.default.RIGHT || anchor.x === _HorizontalAnchors2.default.INNER_RIGHT) {
	      _this4._lastXFix = 'left';
	    } else {
	      // Can't fix others
	      _this4._lastXFix = null;
	    }
	
	    if (anchor.y === _VerticalAnchors2.default.BOTTOM) {
	      _this4._initialTop = top + height;
	    }
	
	    if (fixedTo !== window && !fixedTo.y && !fixedTo.x) {
	      var _scroll2 = (0, _getScroll2.default)(window);
	      _this4._initialWinX = _scroll2.x;
	      _this4._initialWinY = _scroll2.y;
	    }
	
	    var styles = _this4._mergeStyles({
	      left: _this4._initialLeft,
	      top: _this4._initialTop,
	      transformOrigin: undefined,
	      width: sameWidth ? width : undefined
	    });
	
	    _this4.setState({ styles: styles });
	  };
	
	  this._reset = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props,
	        fixedTo = _ref2.fixedTo;
	
	    // Reset all the bookkeeping variables for a fresh start on re-visible
	    _this4._lastXFix = null;
	    _this4._lastYFix = null;
	    _this4._initialX = null;
	    _this4._initialY = null;
	    _this4._initialTop = null;
	    _this4._initialLeft = null;
	
	    if (!_this4._inFixed) {
	      if (_this4._dialog) {
	        _this4._manageFixedToListener(_this4._dialog, false);
	      }
	
	      _this4._manageFixedToListener(fixedTo, false);
	    }
	  };
	
	  this._setContainer = function (container) {
	    _this4._container = (0, _reactDom.findDOMNode)(container);
	    _this4._toggle = null;
	    if (!_this4._container) {
	      return;
	    }
	
	    var _props5 = _this4.props,
	        toggleQuery = _props5.toggleQuery,
	        onContextMenu = _props5.onContextMenu;
	
	    if (typeof toggleQuery === 'function') {
	      _this4._toggle = toggleQuery();
	    } else if (typeof toggleQuery === 'string') {
	      _this4._toggle = _this4._container.querySelector(toggleQuery);
	    } else {
	      _this4._toggle = toggleQuery;
	    }
	
	    if (!_this4._toggle && !onContextMenu && ("production") !== 'production') {
	      var error = new Error('Unable to find a toggle component with the provided `toggleQuery` and `toggle` element. \n' + ('`toggleQuery`: `' + toggleQuery + '`'));
	      error.toggleQuery = toggleQuery;
	      error.toggle = _this4.props.toggle;
	
	      throw error;
	    }
	
	    var node = _this4._container;
	    while (node) {
	      var fixed = window.getComputedStyle(node).position === 'fixed';
	      if (fixed && node.className.match(/md-dialog--(full-page|centered)/)) {
	        _this4._dialog = node;
	        return;
	      } else if (fixed && !node.classList.contains('md-layover-child')) {
	        _this4._inFixed = true;
	        return;
	      }
	
	      node = node.offsetParent;
	    }
	  };
	
	  this._initialFix = function () {
	    // Need to make a clone that disables any transitions to calculate positioning stuff
	    var clone = _this4._child.cloneNode(true);
	    clone.style.webkitTransform = 'none';
	    clone.style.transfrom = 'none';
	    clone.style.webkitTransition = 'none';
	    clone.style.transition = 'none';
	
	    _this4._child.parentNode.appendChild(clone);
	    var vp = (0, _viewport2.default)(clone);
	    var childHeight = clone.offsetHeight,
	        childWidth = clone.offsetWidth;
	
	    _this4._child.parentNode.removeChild(clone);
	
	    if (vp === true || !_this4._toggle || !_this4._child) {
	      return;
	    }
	
	    var _getAnchor2 = _this4._getAnchor(_this4.props),
	        x = _getAnchor2.x,
	        y = _getAnchor2.y;
	
	    var toggleHeight = void 0;
	    var toggleWidth = void 0;
	    if (_this4._contextRect) {
	      toggleHeight = _this4._contextRect.height;
	      toggleWidth = _this4._contextRect.width;
	    } else {
	      toggleHeight = _this4._toggle.offsetHeight;
	      toggleWidth = _this4._toggle.offsetWidth;
	    }
	
	    var addToTop = 0;
	    var addToLeft = 0;
	
	    // Android devices will never get this far because they consider the keyboard as part
	    // of the viewport, iOS will and cause it to be a giant negative number. *sigh*
	    // Prevent any additional vertical positioning for iOS
	    if (!_this4.props.fillViewportHeight && (!vp.top || !vp.bottom)) {
	      var multiplier = vp.top ? -1 : 1;
	      if (!vp.bottom && y === _VerticalAnchors2.default.OVERLAP) {
	        addToTop += toggleHeight;
	      } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	        addToTop += multiplier * toggleHeight;
	      }
	
	      addToTop += multiplier * childHeight;
	
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (!_this4.props.fillViewportWidth && x !== _HorizontalAnchors2.default.CENTER && (!vp.left || !vp.right)) {
	      if (!vp.left && x === _HorizontalAnchors2.default.LEFT) {
	        addToLeft += toggleWidth + childWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.left && x === _HorizontalAnchors2.default.INNER_LEFT) {
	        addToLeft += toggleWidth;
	        _this4._lastXFix = 'left';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.RIGHT) {
	        addToLeft -= toggleWidth + childWidth;
	        _this4._lastXFix = 'right';
	      } else if (!vp.right && x === _HorizontalAnchors2.default.INNER_RIGHT) {
	        addToLeft -= toggleWidth;
	        _this4._lastXFix = 'right';
	      }
	    }
	
	    if (addToTop !== 0 || addToLeft !== 0) {
	      _this4._initialTop += addToTop;
	      _this4._initialLeft += addToLeft;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop, left: _this4._initialLeft }) });
	    }
	  };
	
	  this._fixateChild = function (child) {
	    _this4._child = (0, _reactDom.findDOMNode)(child);
	
	    if (_this4._child !== null) {
	      _this4._childComponent = _react2.default.Children.only(_this4.props.children);
	
	      // If child also has a ref callback, simulate the same thing
	      if (typeof _this4._childComponent.ref === 'function') {
	        _this4._childComponent.ref(child);
	      }
	
	      if (_this4.props.simplified || !_this4._child || !_this4._toggle && !_this4._contextRect) {
	        return;
	      }
	
	      if (_this4._dialog && _this4._dialog.classList.contains('md-dialog--centered')) {
	        return;
	      }
	
	      _this4._manageWindowResizeListener(true);
	      _this4._positionChild();
	    } else if (_this4._childComponent && typeof _this4._childComponent.ref === 'function') {
	      _this4._childComponent.ref(child);
	    }
	  };
	
	  this._positionChild = function () {
	    var centered = _this4.props.centered;
	
	    var anchor = _this4._getAnchor(_this4.props);
	    var rect = _this4._contextRect || _this4._toggle.getBoundingClientRect();
	    _this4._height = rect.height;
	    _this4._width = rect.width;
	    var styles = _this4._createStyles(anchor, centered, _this4._child, rect);
	    if (styles.top || styles.left) {
	      _this4._initialLeft = styles.left || _this4._initialLeft;
	      _this4._initialTop = styles.top || _this4._initialTop;
	      _this4.setState({ styles: _this4._mergeStyles(styles) }, _this4._initialFix);
	    } else {
	      _this4._initialFix();
	    }
	  };
	
	  this._handleResize = function () {
	    if (_this4.props.visible) {
	      _this4._positionChild();
	    }
	  };
	
	  this._handleScroll = function (e) {
	    if (!_this4.props.repositionOnScroll) {
	      _this4._manageFixedToListener(_this4.props.fixedTo, false);
	      _this4.props.onClose(e);
	    }
	
	    if (!_this4._ticking) {
	      requestAnimationFrame(function () {
	        return _this4._handleTick(e);
	      });
	    }
	
	    _this4._ticking = true;
	  };
	
	  this._handleTick = function (e) {
	    var _props6 = _this4.props,
	        fixedTo = _props6.fixedTo,
	        xThreshold = _props6.xThreshold,
	        yThreshold = _props6.yThreshold;
	
	    var vp = (0, _viewport2.default)(_this4._child);
	    if (vp !== true && vp.left && vp.right) {
	      var fixed = !_this4._contextRect && _this4._attemptFix(vp);
	      if (!fixed) {
	        _this4.props.onClose(e);
	        _this4._ticking = false;
	      }
	
	      return;
	    } else if ((0, _isOutOfBounds2.default)(fixedTo, _this4._child, _this4._toggle, yThreshold, xThreshold)) {
	      _this4.props.onClose(e);
	      _this4._ticking = false;
	      return;
	    }
	
	    var x = void 0;
	    var y = void 0;
	    if (_this4._dialog) {
	      var scroll = (0, _getScroll2.default)(_this4._dialog);
	      x = scroll.x;
	      y = scroll.y;
	    } else if (fixedTo !== window && (fixedTo.x || fixedTo.y)) {
	      x = (0, _getScroll2.default)(fixedTo.x || window).x;
	      y = (0, _getScroll2.default)(fixedTo.y || window).y;
	    } else {
	      var _scroll3 = (0, _getScroll2.default)(fixedTo);
	      x = _scroll3.x;
	      y = _scroll3.y;
	    }
	
	    var winX = void 0;
	    var winY = void 0;
	    // When using the additional fixedTo stuff, need to also keep track of the entire
	    // window's scrolling..
	    if (fixedTo !== window && !fixedTo.x && !fixedTo.y) {
	      var _scroll4 = (0, _getScroll2.default)(window);
	      winX = _scroll4.x;
	      winY = _scroll4.y;
	    }
	
	    var styles = _this4.state.styles;
	    var left = styles.left,
	        top = styles.top;
	
	    if (_this4._initialX !== x) {
	      left = _this4._initialX - x + _this4._initialLeft;
	    }
	
	    if (winX && _this4._initialWinX !== winX) {
	      left = _this4._initialWinX - winX + _this4._initialX;
	    }
	
	    if (_this4._initialY !== y) {
	      top = _this4._initialY - y + _this4._initialTop;
	    }
	
	    if (winY && _this4._initialWinY !== winY) {
	      top = _this4._initialWinY - winY + _this4._initialTop + (_this4._initialY - y);
	    }
	
	    if (styles.top !== top || styles.left !== left) {
	      _this4.setState({ styles: _this4._mergeStyles({ left: left, top: top }) }, function () {
	        _this4._ticking = false;
	      });
	    } else {
	      _this4._ticking = false;
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this4._contextRect && _this4._child && !_this4._child.contains(e.target) || _this4._container && !_this4._container.contains(e.target)) {
	      _this4.props.onClose(e);
	    }
	  };
	
	  this._handleWindowResize = function (e) {
	    var _props7 = _this4.props,
	        onClose = _props7.onClose,
	        repositionOnResize = _props7.repositionOnResize;
	
	    if (repositionOnResize) {
	      _this4._handleResize();
	    } else {
	      onClose(e);
	      _this4._manageWindowResizeListener(false);
	    }
	  };
	
	  this._attemptFix = function (vp) {
	    var _getAnchor3 = _this4._getAnchor(_this4.props),
	        x = _getAnchor3.x,
	        y = _getAnchor3.y;
	
	    var centered = x === _HorizontalAnchors2.default.CENTER && y === _VerticalAnchors2.default.CENTER && _this4.props.centered;
	    if (centered || _this4._lastYFix === 'top' && !vp.top || _this4._lastYFix === 'bottom' && !vp.bottom) {
	      return false;
	    }
	
	    var toggleTop = _this4._toggle.getBoundingClientRect().top;
	    var toggleHeight = _this4._toggle.offsetHeight;
	    var childHeight = _this4._child.offsetHeight;
	
	    // Can;t fix if the child can't fit on the page based on the toggle's position
	
	    if (toggleTop + toggleHeight + childHeight > window.innerHeight) {
	      return false;
	    }
	
	    var _child$getBoundingCli = _this4._child.getBoundingClientRect(),
	        top = _child$getBoundingCli.top;
	
	    var newTop = _this4._initialTop;
	    var addToTop = childHeight * (vp.top ? -1 : 1);
	    if (y === _VerticalAnchors2.default.OVERLAP) {
	      addToTop += (vp.top ? 1 : -1) * toggleHeight;
	    } else if (y === _VerticalAnchors2.default.TOP || y === _VerticalAnchors2.default.BOTTOM) {
	      addToTop += (_this4._lastYFix === 'top' ? -1 : 1) * toggleHeight;
	    }
	
	    if (addToTop !== 0) {
	      newTop = top + addToTop;
	      _this4._lastYFix = vp.top ? 'bottom' : 'top';
	    }
	
	    if (newTop !== _this4._initialTop) {
	      _this4._initialTop = newTop;
	      var fixedTo = _this4.props.fixedTo;
	
	      var scrollEl = fixedTo;
	      if (fixedTo !== window && (fixedTo.y || fixedTo.x)) {
	        scrollEl = fixedTo.y || window;
	      }
	
	      _this4._initialY = (0, _getScroll2.default)(scrollEl).y;
	
	      _this4.setState({ styles: _this4._mergeStyles({ top: _this4._initialTop }) }, function () {
	        _this4._ticking = false;
	      });
	      return true;
	    }
	
	    return false;
	  };
	
	  this._handleContextMenu = function (e) {
	    var anchor = _this4._getAnchor(_this4.props);
	    var _props8 = _this4.props,
	        onContextMenu = _props8.onContextMenu,
	        preventContextMenu = _props8.preventContextMenu,
	        fixedTo = _props8.fixedTo,
	        sameWidth = _props8.sameWidth,
	        centered = _props8.centered,
	        visible = _props8.visible;
	
	    if (!onContextMenu) {
	      return;
	    }
	
	    _this4._contextRect = (0, _getSelectedTextPosition2.default)(e);
	    if (preventContextMenu && (!_this4._child || !_this4._child.contains(e.target))) {
	      e.preventDefault();
	    }
	
	    onContextMenu(e);
	    if (visible) {
	      _this4._init(fixedTo, anchor, sameWidth, centered, _this4._contextRect);
	    }
	  };
	};
	
	exports.default = Layover;
	//# sourceMappingURL=Layover.js.map

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isReact16 = typeof _reactDom.createPortal === 'function';
	
	/**
	 * Creates a "Portal" for the children to be rendered in. Basically it will render the
	 * children only when the `visible` prop is `true`. When it is visible, a new `component`
	 * will be rendered as the first child in the body with the children inside.
	 *
	 * Unlike all the other components, `style` will not be applied for the `Portal`.
	 */
	
	var Portal = function (_PureComponent) {
	  _inherits(Portal, _PureComponent);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._portal = null, _this._applyStyles = function (props) {
	      if (props.className) {
	        _this._container.className = props.className;
	      }
	    }, _this._renderPortal = function (props) {
	      if (!_this._container) {
	        _this._container = document.createElement(props.component);
	
	        _this._applyStyles(props);
	        var node = props.renderNode || document.body;
	        if (props.lastChild) {
	          node.appendChild(_this._container);
	        } else {
	          node.insertBefore(_this._container, node.firstChild);
	        }
	      } else {
	        _this._applyStyles(props);
	      }
	
	      if (!isReact16) {
	        _this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(_this, props.children, _this._container);
	      }
	    }, _this._removePortal = function () {
	      if (_this.props.onClose) {
	        _this.props.onClose();
	      }
	
	      if (_this._container) {
	        if (!isReact16) {
	          (0, _reactDom.unmountComponentAtNode)(_this._container);
	        }
	
	        (_this.props.renderNode || document.body).removeChild(_this._container);
	      }
	
	      _this._portal = null;
	      _this._container = null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.visible) {
	        this._renderPortal(this.props);
	
	        if (isReact16) {
	          // Need to update after the renderPortal created the DOM element.
	          this.forceUpdate();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = nextProps.visible,
	          onOpen = nextProps.onOpen;
	
	      if (this.props.visible === visible) {
	        if (visible && !isReact16) {
	          // Need to just re-render the subtree
	          this._renderPortal(nextProps);
	        }
	
	        return;
	      }
	
	      if (visible) {
	        if (onOpen) {
	          onOpen();
	        }
	
	        this._renderPortal(nextProps);
	      } else {
	        this._removePortal();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.visible && this.props.onClose) {
	        this.props.onClose();
	      }
	      this._removePortal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          className = _props.className,
	          children = _props.children,
	          visible = _props.visible;
	
	      // When doing server side rendering, actually render the component as a direct child of its parent.
	      // Once it has been rendered and working client side, it will be removed correctly.
	
	      if (typeof window === 'undefined' && visible) {
	        return _react2.default.createElement(
	          Component,
	          { className: className },
	          children
	        );
	      } else if (isReact16 && visible && this._container && typeof window !== 'undefined') {
	        return (0, _reactDom.createPortal)(children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.PureComponent);
	
	Portal.propTypes = {
	  /**
	   * An optional className to apply to the newly created `component` when visible.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the children are visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * The children to render when visible.
	   */
	  children: _propTypes2.default.element,
	
	  /**
	   * The component to render as. This should be a valid DOM element.
	   */
	  component: _propTypes2.default.string.isRequired,
	
	  /**
	   * An optional function to call when the portal is opened.
	   */
	  onOpen: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the portal is closed
	   */
	  onClose: _propTypes2.default.func,
	
	  /**
	   * An optional DOM Node to render the portal into. The default is to render as
	   * the first child in the `body`.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the portal should render the children as the last child of the `renderNode`
	   * or `body` instead of the first.
	   */
	  lastChild: _propTypes2.default.bool
	};
	Portal.defaultProps = {
	  component: 'span'
	};
	exports.default = Portal;
	//# sourceMappingURL=Portal.js.map

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/Positions */
	
	/**
	 * An enum for all the animation positions for a layover appearing.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var Positions = {
	  /**
	   * The layover will appear by transitioning from the top left and expand
	   * down right.
	   */
	  TOP_LEFT: 'tl',
	
	  /**
	   * The layover will appear by transitioning from the top right and expand
	   * down left.
	   */
	  TOP_RIGHT: 'tr',
	
	  /**
	   * The layover will appear by transitioning from the bottom left and expand
	   * top right.
	   */
	  BOTTOM_LEFT: 'bl',
	
	  /**
	   * The layover will appear by transitioning from the bottom right and expand
	   * top left.
	   */
	  BOTTOM_RIGHT: 'br',
	
	  /**
	   * The layover will appear by just transitioning downwards from the bottom
	   * of the toggle component.
	   */
	  BELOW: 'below'
	};
	
	exports.default = Positions;
	//# sourceMappingURL=Positions.js.map

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(690);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ResizeObserver` component is a component hook for the
	 * [ResizeObserver](http://rawgit.com/WICG/ResizeObserver/master/index.html)
	 * using the [resize-observer-polyfill](https://github.com/que-etc/resize-observer-polyfill)
	 * for browsers that don't support it yet.
	 *
	 * This component displays an empty `span` with `aria-hidden` to allow access to the DOM. By
	 * default it will attempt to watch changes on its parent component, but it can be configured
	 * to watch any element by using the `target` prop.
	 */
	var ResizeObserver = function (_PureComponent) {
	  _inherits(ResizeObserver, _PureComponent);
	
	  function ResizeObserver() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizeObserver);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResizeObserver.__proto__ || Object.getPrototypeOf(ResizeObserver)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._scrollHeight = null, _this._scrollWidth = null, _this._measure = function (entries) {
	      if (!_this._observer || !_this._target) {
	        return;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var entry = _step.value;
	
	          if (!entry) {
	            return;
	          }
	
	          var _entry$contentRect = entry.contentRect,
	              height = _entry$contentRect.height,
	              width = _entry$contentRect.width;
	          var _entry$target = entry.target,
	              scrollHeight = _entry$target.scrollHeight,
	              scrollWidth = _entry$target.scrollWidth;
	
	          if (_this._isHeightChange(height, scrollHeight) || _this._isWidthChange(width, scrollWidth)) {
	            _this._height = height;
	            _this._width = width;
	            _this._scrollHeight = scrollHeight;
	            _this._scrollWidth = scrollWidth;
	            _this.props.onResize({ height: height, width: width, scrollHeight: scrollHeight, scrollWidth: scrollWidth, el: entry.target });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }, _this._isHeightChange = function (height, scrollHeight) {
	      return _this.props.watchHeight && (height !== _this._height || scrollHeight !== _this._scrollHeight);
	    }, _this._isWidthChange = function (width, scrollWidth) {
	      return _this.props.watchWidth && (width !== _this._width || scrollWidth !== _this._scrollWidth);
	    }, _this._handleRef = function (container) {
	      if (container) {
	        _this._container = container;
	        _this._target = _this._getTarget(container, _this.props.target);
	        _this._observer = new _resizeObserverPolyfill2.default(_this._measure);
	
	        if (_this._target) {
	          _this._observer.observe(_this._target);
	        }
	      } else {
	        if (_this._observer) {
	          _this._observer.disconnect();
	        }
	
	        _this._container = null;
	        _this._target = null;
	        _this._observer = null;
	        _this._height = null;
	        _this._width = null;
	        _this._scrollHeight = null;
	        _this._scrollWidth = null;
	      }
	
	      if (_this.props.elRef) {
	        _this.props.elRef(_this._target);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResizeObserver, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var target = this.props.target;
	
	      var nextTarget = nextProps.target;
	      if (target === nextTarget) {
	        return;
	      } else if (nextTarget) {
	        if (this._target) {
	          this._observer.unobserve(this._target);
	        }
	        this._target = this._getTarget(this._container, nextTarget);
	        this._observer.observe(this._target);
	      }
	    }
	  }, {
	    key: '_getTarget',
	    value: function _getTarget(container, target) {
	      if (target === null || target && typeof target !== 'string') {
	        return target;
	      }
	
	      var t = null;
	      if (target) {
	        t = document.getElementById(target) || document.querySelector(target);
	      } else {
	        t = container.parentNode;
	      }
	
	      if (!t) {
	        throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
	      }
	
	      return t;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Component = this.props.component;
	
	      return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
	    }
	  }]);
	
	  return ResizeObserver;
	}(_react.PureComponent);
	
	ResizeObserver.propTypes = {
	  /**
	   * Boolean if the height should be watched for the resize target.
	   */
	  watchHeight: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the width should be watched for the resize target.
	   */
	  watchWidth: _propTypes2.default.bool,
	
	  /**
	   * An optional target that should be used for detecting resize events. This can either
	   * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
	   *
	   * If this prop is not provided and not null, it will default to the parent node of this component.
	   * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
	   * it has been correctly passed a target string or object.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * The component to be rendered as. This should normally just be the default `span`, but there are cases
	   * where the component should be switched to something else for valid html.
	   */
	  component: _propTypes2.default.string,
	
	  /**
	   * A function to call when the height or width has been changed and that attribute is being watched.
	   * The callback will include the current height, width, scrollHeight and scrollWidth of the target.
	   *
	   * ```js
	   * onResize({
	   *   height: nextHeight,
	   *   width: nextWidth,
	   *   scrollHeight: nextScrollHeight,
	   *   scrollWidth: nextScrollWidth,
	   *   el: resizeTarget,
	   * });
	   * ```
	   */
	  onResize: _propTypes2.default.func.isRequired,
	
	  /**
	   * An optional ref callback that will include the `target` or the parent node of the resize observer. Just
	   * like other refs, this will provide null when it unmounts.
	   *
	   * This is really only helpful if you'd like the DOM node for a parent Component without needing to use
	   * `ReactDOM.findDOMNode(this)`.
	   */
	  elRef: _propTypes2.default.func
	};
	ResizeObserver.defaultProps = {
	  watchHeight: false,
	  watchWidth: false,
	  component: 'span'
	};
	exports.default = ResizeObserver;
	//# sourceMappingURL=ResizeObserver.js.map

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/** @module Helpers/VerticalAnchors */
	
	/**
	 * An enum for all the different types of horizontal anchors on a layover.
	 *
	 * @readonly
	 * @enum {string}
	 */
	var VerticalAnchors = {
	  /**
	   * Positions the layover to be placed over the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  TOP: 'top',
	
	  /**
	   * Positions the layover so that it will be centered over the toggle component
	   * based on the layover's height.
	   */
	  CENTER: 'center',
	
	  /**
	   * Positions the layover so that it will overlap the toggle component by
	   * fixing to the top of the toggle.
	   */
	  OVERLAP: 'overlap',
	
	  /**
	   * Positions the layover to be placed below the toggle component so that
	   * it will never overlay the toggle component.
	   */
	  BOTTOM: 'bottom'
	};
	
	exports.default = VerticalAnchors;
	//# sourceMappingURL=VerticalAnchors.js.map

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HorizontalAnchors = __webpack_require__(218);
	
	var _HorizontalAnchors2 = _interopRequireDefault(_HorizontalAnchors);
	
	var _VerticalAnchors = __webpack_require__(221);
	
	var _VerticalAnchors2 = _interopRequireDefault(_VerticalAnchors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  x: _propTypes2.default.oneOf([_HorizontalAnchors2.default.LEFT, _HorizontalAnchors2.default.INNER_LEFT, _HorizontalAnchors2.default.CENTER, _HorizontalAnchors2.default.RIGHT, _HorizontalAnchors2.default.INNER_RIGHT]).isRequired,
	  y: _propTypes2.default.oneOf([_VerticalAnchors2.default.TOP, _VerticalAnchors2.default.CENTER, _VerticalAnchors2.default.OVERLAP, _VerticalAnchors2.default.BOTTOM]).isRequired
	});
	//# sourceMappingURL=anchorShape.js.map

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.shape({
	  x: _propTypes2.default.object,
	  y: _propTypes2.default.object
	})]);
	//# sourceMappingURL=fixedToShape.js.map

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Positions = __webpack_require__(220);
	
	var _Positions2 = _interopRequireDefault(_Positions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.oneOfType([_propTypes2.default.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]), _propTypes2.default.string]);
	//# sourceMappingURL=positionShape.js.map

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _getField = __webpack_require__(28);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _fixedToShape = __webpack_require__(98);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _Subheaders = __webpack_require__(574);
	
	var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Lists present multiple line items vertically as a single continuous element.
	 */
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(List, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _context = this.context,
	          listLevel = _context.listLevel,
	          context = _objectWithoutProperties(_context, ['listLevel']);
	
	      var cascadingFixedTo = (0, _getField2.default)(this.state, this.context, 'cascadingFixedTo');
	      return _extends({}, context, {
	        cascadingFixedTo: cascadingFixedTo,
	        listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.context.cascadingMenu) {
	        var list = (0, _reactDom.findDOMNode)(this);
	        if (list.offsetHeight < list.scrollHeight) {
	          var cascadingFixedTo = { y: (0, _reactDom.findDOMNode)(this) };
	          this.setState({ cascadingFixedTo: cascadingFixedTo }); // eslint-disable-line react/no-did-mount-set-state
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props = this.props,
	          className = _props.className,
	          ordered = _props.ordered,
	          children = _props.children,
	          subheader = _props.subheader,
	          inline = _props.inline,
	          primarySubheader = _props.primarySubheader,
	          props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'inline', 'primarySubheader']);
	
	      var _context2 = this.context,
	          cascadingMenu = _context2.cascadingMenu,
	          cascadingZDepth = _context2.cascadingZDepth,
	          listLevel = _context2.listLevel;
	
	
	      var subheaderEl = void 0;
	      if (subheader) {
	        subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
	      }
	
	      var Component = ordered ? 'ol' : 'ul';
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-list', (_cn = {
	            'md-list--inline': inline,
	            'md-list--menu-cascading': cascadingMenu
	          }, _defineProperty(_cn, 'md-paper md-paper--' + cascadingZDepth, cascadingZDepth && cascadingMenu && listLevel > 0), _defineProperty(_cn, 'md-list--nested-' + listLevel, listLevel && !cascadingMenu), _cn), className)
	        }),
	        subheaderEl,
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent);
	
	List.propTypes = {
	  /**
	   * An optional style to apply to the list.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the list.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
	   * be rendered as `<ul>`.
	   */
	  ordered: _propTypes2.default.bool,
	
	  /**
	   * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
	   * `Subheader`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list should appear horizontally instead of vertically.
	   */
	  inline: _propTypes2.default.bool,
	  subheader: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `Subheader` component as a child instead'),
	  primarySubheader: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `Subheader` component as a child instead')
	};
	List.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	List.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = List;
	//# sourceMappingURL=List.js.map

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _themeColors = __webpack_require__(58);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	var _getCollapserStyles = __webpack_require__(236);
	
	var _getCollapserStyles2 = _interopRequireDefault(_getCollapserStyles);
	
	var _getField = __webpack_require__(28);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(102);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _keyCodes = __webpack_require__(43);
	
	var _anchorShape = __webpack_require__(146);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(98);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _AccessibleFakeInkedButton = __webpack_require__(216);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _Collapse = __webpack_require__(217);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _FontIcon = __webpack_require__(26);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(145);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _TileAddon = __webpack_require__(224);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	var _ListItemText = __webpack_require__(567);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _List = __webpack_require__(99);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Menu = __webpack_require__(568);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItem` component is used for rendering a `li` tag with text and optional
	 * icons/avatars.
	 */
	var ListItem = function (_PureComponent) {
	  _inherits(ListItem, _PureComponent);
	
	  function ListItem(props) {
	    _classCallCheck(this, ListItem);
	
	    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = { active: false };
	
	    if (typeof props.isOpen === 'undefined' && typeof props.visible === 'undefined') {
	      var defined = function defined(v) {
	        return typeof v !== 'undefined';
	      };
	      var _this$props = _this.props,
	          initiallyOpen = _this$props.initiallyOpen,
	          defaultOpen = _this$props.defaultOpen,
	          defaultVisible = _this$props.defaultVisible;
	
	      var visible = defined(initiallyOpen) ? initiallyOpen : defaultVisible;
	      visible = defined(defaultOpen) ? defaultOpen : visible;
	      visible = !!visible;
	
	      _this.state.visible = visible;
	    }
	    return _this;
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.active) {
	        window.removeEventListener('click', this._handleOutsideClick);
	      }
	
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	
	    /**
	     * A utility function to focus the `AccessibleFakeInkedButton` in the `ListItem` and also
	     * inject an ink to indicate focus.
	     */
	
	
	    /**
	     * A utility function to blur the `AccessibleFakeInkedButton` in the `ListItem`.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          contentStyle = _props.contentStyle,
	          contentClassName = _props.contentClassName,
	          leftNodeStyle = _props.leftNodeStyle,
	          leftNodeClassName = _props.leftNodeClassName,
	          rightNodeStyle = _props.rightNodeStyle,
	          rightNodeClassName = _props.rightNodeClassName,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          nestedListStyle = _props.nestedListStyle,
	          nestedListClassName = _props.nestedListClassName,
	          nestedListHeightRestricted = _props.nestedListHeightRestricted,
	          disabled = _props.disabled,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          inset = _props.inset,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          nestedItems = _props.nestedItems,
	          prependNested = _props.prependNested,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          activeBoxStyle = _props.activeBoxStyle,
	          activeBoxClassName = _props.activeBoxClassName,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderLeft = _props.expanderLeft,
	          component = _props.component,
	          ItemComponent = _props.itemComponent,
	          itemProps = _props.itemProps,
	          tileProps = _props.tileProps,
	          passPropsToItem = _props.passPropsToItem,
	          ariaSize = _props['aria-setsize'],
	          ariaPos = _props['aria-posinset'],
	          isOpen = _props.isOpen,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          propVisible = _props.visible,
	          defaultVisible = _props.defaultVisible,
	          itemRef = _props.itemRef,
	          defaultOpen = _props.defaultOpen,
	          initiallyOpen = _props.initiallyOpen,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'contentStyle', 'contentClassName', 'leftNodeStyle', 'leftNodeClassName', 'rightNodeStyle', 'rightNodeClassName', 'primaryTextStyle', 'primaryTextClassName', 'secondaryTextStyle', 'secondaryTextClassName', 'nestedListStyle', 'nestedListClassName', 'nestedListHeightRestricted', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'prependNested', 'active', 'activeClassName', 'activeBoxStyle', 'activeBoxClassName', 'animateNestedItems', 'expanderIcon', 'expanderLeft', 'component', 'itemComponent', 'itemProps', 'tileProps', 'passPropsToItem', 'aria-setsize', 'aria-posinset', 'isOpen', 'expanderIconChildren', 'expanderIconClassName', 'visible', 'defaultVisible', 'itemRef', 'defaultOpen', 'initiallyOpen']);
	
	      var _context = this.context,
	          cascadingId = _context.cascadingId,
	          cascadingMenu = _context.cascadingMenu,
	          cascadingAnchor = _context.cascadingAnchor,
	          cascadingFixedTo = _context.cascadingFixedTo;
	
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      if (typeof isOpen !== 'undefined') {
	        visible = isOpen;
	      }
	
	      var leftNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'left-addon',
	        style: leftNodeStyle,
	        className: leftNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: leftIcon,
	        avatar: leftAvatar
	      });
	
	      var rightNode = _react2.default.createElement(_TileAddon2.default, {
	        key: 'right-addon',
	        style: rightNodeStyle,
	        className: rightNodeClassName,
	        active: active,
	        activeClassName: activeClassName,
	        icon: rightIcon,
	        avatar: rightAvatar
	      });
	
	      var nestedList = void 0;
	      if (nestedItems) {
	        if (!cascadingMenu) {
	          nestedList = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !visible, animate: animateNestedItems },
	            _react2.default.createElement(
	              _List2.default,
	              { style: nestedListStyle, className: nestedListClassName },
	              nestedItems
	            )
	          );
	        }
	
	        var icon = _react2.default.Children.only((0, _getDeprecatedIcon2.default)(expanderIconClassName, expanderIconChildren, expanderIcon));
	        var collapser = _react2.default.createElement(_TileAddon2.default, {
	          key: 'expander-addon',
	          icon: _react2.default.cloneElement(icon, {
	            className: (0, _getCollapserStyles2.default)({ flipped: visible }, icon.props.className)
	          }),
	          avatar: null
	        });
	
	        if (expanderLeft) {
	          if (!leftIcon && !leftAvatar) {
	            leftNode = collapser;
	          }
	        } else if (!rightIcon && !rightAvatar) {
	          rightNode = collapser;
	        }
	      }
	
	      var icond = !!leftIcon || !!rightIcon || !!nestedItems;
	      var avatard = !!leftAvatar || !!rightAvatar;
	
	      var tile = _react2.default.createElement(
	        _AccessibleFakeInkedButton2.default,
	        _extends({}, tileProps, passPropsToItem ? undefined : props, {
	          component: component,
	          __SUPER_SECRET_REF__: this._setTile,
	          key: 'tile',
	          onClick: this._handleClick,
	          onMouseOver: this._handleMouseOver,
	          onMouseLeave: this._handleMouseLeave,
	          onTouchStart: this._handleTouchStart,
	          onTouchEnd: this._handleTouchEnd,
	          onKeyDown: this._handleKeyDown,
	          onKeyUp: this._handleKeyUp,
	          disabled: disabled,
	          style: tileStyle,
	          className: (0, _classnames2.default)('md-list-tile', {
	            'md-list-tile--active': this.state.active && !this._touched,
	            'md-list-tile--icon': !secondaryText && icond && !avatard,
	            'md-list-tile--avatar': !secondaryText && avatard,
	            'md-list-tile--two-lines': secondaryText && !threeLines,
	            'md-list-tile--three-lines': secondaryText && threeLines,
	            'md-list-item--inset': inset && !leftIcon && !leftAvatar
	          }, (0, _themeColors2.default)({ disabled: disabled, text: true }), tileClassName),
	          'aria-expanded': nestedList && !cascadingMenu ? visible : null
	        }),
	        leftNode,
	        _react2.default.createElement(_ListItemText2.default, {
	          active: active,
	          activeClassName: activeClassName,
	          disabled: disabled,
	          primaryText: primaryText,
	          secondaryText: secondaryText,
	          threeLines: threeLines,
	          style: contentStyle,
	          className: (0, _classnames2.default)({
	            'md-tile-content--left-icon': leftIcon || expanderLeft && nestedItems,
	            'md-tile-content--left-avatar': leftAvatar,
	            'md-tile-content--right-padding': rightIcon || rightAvatar
	          }, contentClassName),
	          primaryTextStyle: primaryTextStyle,
	          primaryTextClassName: primaryTextClassName,
	          secondaryTextStyle: secondaryTextStyle,
	          secondaryTextClassName: secondaryTextClassName
	        }),
	        rightNode,
	        children
	      );
	
	      var sharedProps = _extends({}, itemProps, passPropsToItem ? props : undefined, {
	        style: Object.assign({}, style, active ? activeBoxStyle : null),
	        className: (0, _classnames2.default)('md-list-item', _defineProperty({
	          'md-list-item--nested-container': nestedItems
	        }, activeBoxClassName, activeBoxClassName && active), className),
	        'aria-setsize': ariaSize,
	        'aria-posinset': ariaPos,
	        ref: this._setContainer
	      });
	      if (cascadingMenu && nestedItems) {
	        return _react2.default.createElement(
	          _Menu2.default,
	          _extends({
	            id: cascadingId,
	            visible: visible,
	            onClose: this._handleClick,
	            toggle: tile,
	            block: true,
	            simplified: false,
	            anchor: cascadingAnchor,
	            belowAnchor: null,
	            position: _Menu2.default.Positions.BELOW,
	            component: ItemComponent,
	            listStyle: nestedListStyle,
	            listClassName: nestedListClassName,
	            listHeightRestricted: nestedListHeightRestricted
	          }, sharedProps, {
	            fixedTo: cascadingFixedTo
	          }),
	          nestedItems
	        );
	      }
	
	      return _react2.default.createElement(
	        ItemComponent,
	        sharedProps,
	        prependNested ? nestedList : null,
	        tile,
	        prependNested ? null : nestedList
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.PureComponent);
	
	ListItem.propTypes = {
	  /**
	   * An optional style to apply to the `li` tag.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `li` tag.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `.md-list-tile`.
	   *
	   * @see {@link #component}
	   */
	  tileClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div that surrounds the `primaryText` and `secondaryText`
	   * nodes.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered before content node.
	   */
	  leftNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered before content node.
	   */
	  leftNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the element that is rendered after content node.
	   */
	  rightNodeStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the element that is rendered after content node.
	   */
	  rightNodeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `primaryText`.
	   */
	  primaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the div surrounding the `secondaryText`.
	   */
	  secondaryTextClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the nested `List` that gets created when using `nestedItems`.
	   */
	  nestedListClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested `List` in a cascading menu should be restricted.
	   */
	  nestedListHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Any additional children to display in the `.md-list-tile`. If you use this prop,
	   * you will most likely need to override the `height` for the `.md-list-tile--icon`,
	   * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
	   * to get it to display correctly unless the children are positioned `absolute`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `ListItem` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
	   * `AccessibleFakeButton`'s `tabIndex` default prop value.
	   */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * The primary text to display. This will only be rendered as a single line. Any overflown
	   * text will be converted to ellipsis.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * An optional secondary text to display below the `primaryText`. This can be an additional
	   * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
	   *
	   * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
	   */
	  secondaryText: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the left of the text.
	   */
	  leftIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  leftAvatar: _propTypes2.default.node,
	
	  /**
	   * An optional `FontIcon` to display to the right of the text.
	   */
	  rightIcon: _propTypes2.default.node,
	
	  /**
	   * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
	   * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	   * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	   */
	  rightAvatar: _propTypes2.default.node,
	
	  /**
	   * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
	   * This is used for some lists where only a parent contains the icon.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `secondaryText` should span two lines instead of one. This will include
	   * three lines of text in total when including the `primaryText`.
	   */
	  threeLines: _propTypes2.default.bool,
	
	  /**
	   * The component to render the `.md-list-tile` as. This is mostly useful if you
	   * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
	   * component.
	   *
	   * This prop is **not** the top-most element of the `ListItem` component. To change the
	   * top-most element, see the `itemComponent` prop.
	   *
	   * @see {@link #itemComponent}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * The component to render the top-most element of the `ListItem` component. This is the
	   * `.md-list-item` and defaults to the `<li>` element.
	   *
	   * @see {@link #component}
	   * @see {@link #itemProps}
	   */
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  /**
	   * An optional ref callback to get reference to the top-most element of the `ListItem` component.
	   * Just like other refs, this will provide null when it unmounts.
	   */
	  itemRef: _propTypes2.default.func,
	
	  /**
	   * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
	   * to render in a nested list. This will inject an expander icon to the right of the text
	   * in the `.md-list-tile` that rotates 180 degrees when open.
	   *
	   * The nested items will be visible once the user clicks on the `ListItem`.
	   *
	   * @see {@link #visible}
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
	
	  /**
	   * An optional parameter determining whether `nestedItems` should be placed before or after `ListItemText`
	   */
	  prependNested: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
	   * and require the `onClick` function to be defined.
	   *
	   * @see {@link #defaultVisible}
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onClick', 'defaultVisible'),
	
	  /**
	   * An icon to use for the expander icon when there are nested items.
	   */
	  expanderIcon: _propTypes2.default.element,
	
	  /**
	   * Boolean if the expander icon should appear as the left icon instead of the right.
	   */
	  expanderLeft: _propTypes2.default.bool,
	
	  /**
	   * An optional function to call when the `.md-list-tile` is clicked. This is required if the
	   * `visible` prop is defined.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
	   */
	  onMouseLeave: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
	   */
	  onTouchStart: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
	   */
	  onTouchEnd: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
	   */
	  onKeyUp: _propTypes2.default.func,
	
	  /**
	   * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
	   * to the `leftIcon`, `rightIcon`, and the `primaryText`.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
	   * prop is `true`.
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxStyle: _propTypes2.default.object,
	
	  /**
	   * The className to apply to the top-most element of the `ListItem` component (`.md-list-item`)
	   * when the `active` prop is `true`.
	   */
	  activeBoxClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the nested items should animate when they appear or disappear.
	   */
	  animateNestedItems: _propTypes2.default.bool,
	
	  /**
	   * Defines the number of items in the list. This is only required when all items in the
	   * list are not present in the DOM.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-setsize
	   */
	  'aria-setsize': _propTypes2.default.number,
	
	  /**
	   * Defines the items position in the list. This is only required when all items in the list
	   * are not present in the DOM. The custom validation just requires this prop if the `aria-setsize`
	   * prop is defined as a helpful reminder.
	   *
	   * @see https://www.w3.org/TR/wai-aria/states_and_properties#aria-posinset
	   */
	  'aria-posinset': function ariaPosinset(props, propName) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var validator = _propTypes2.default.number;
	    if (typeof props['aria-setsize'] !== 'undefined') {
	      validator = validator.isRequired;
	    }
	
	    return validator.apply(undefined, [props, propName].concat(args));
	  },
	
	  /**
	   * Any additional props you would like to supply to the surrounding `<li>` tag for the `ListItem`.
	   * By default, all props will be provided to the inner `AccessibleFakeButton`. If the `passPropsToItem`
	   * prop is enabled, the remaining props will be provided to the `<li>` tag instead and this prop
	   * is probably useless.
	   */
	  itemProps: _propTypes2.default.object,
	
	  /**
	   * Any additional props you would like to add to the inner `AccessibleFakeButton`. By default, all the
	   * remaining props will be provided to the `AccessibleFakeButton`, so this prop is probably useless.
	   * Enabling the `passPropsToItem` prop will change the default behavior so that the remaining props
	   * are provided to the surrounding `<li>` node instead and this prop becomes useful.
	   */
	  tileProps: _propTypes2.default.object,
	
	  /**
	   * All the remaining props should be passed to the surrounding `<li>` node instead of the `AccessibleFakeButton`.
	   *
	   * > NOTE: This will most likely become the default in the next *major* release. Migration warnings will be added
	   * if that is the case.
	   */
	  passPropsToItem: _propTypes2.default.bool,
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `expanderIcon` instead'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `expanderIcon` instead'),
	  initiallyOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  defaultOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultVisible` instead'),
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead')
	};
	ListItem.defaultProps = {
	  animateNestedItems: true,
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li',
	  expanderIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'keyboard_arrow_down'
	  )
	};
	ListItem.contextTypes = {
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingFixedTo: _fixedToShape2.default
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.focus = function () {
	    if (_this2._tile) {
	      _this2._tile.focus();
	    }
	  };
	
	  this.blur = function () {
	    if (_this2._tile) {
	      _this2._tile.blur();
	    }
	  };
	
	  this._setTile = function (tile) {
	    if (tile) {
	      _this2._tile = tile;
	      _this2._tileNode = (0, _reactDom.findDOMNode)(tile);
	    }
	  };
	
	  this._setContainer = function (container) {
	    var itemRef = _this2.props.itemRef;
	
	    if (container) {
	      _this2._container = (0, _reactDom.findDOMNode)(container);
	    }
	    if (itemRef) {
	      itemRef(container ? _this2._container : null);
	    }
	  };
	
	  this._handleOutsideClick = function (e) {
	    if (_this2._container && !_this2._container.contains(e.target)) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleClick = function (e) {
	    if (_this2.props.onClick) {
	      _this2.props.onClick(e);
	    }
	
	    if (typeof _this2.state.visible !== 'undefined') {
	      _this2.setState({ visible: !_this2.state.visible });
	    }
	  };
	
	  this._handleMouseOver = function (e) {
	    if (_this2.props.onMouseOver) {
	      _this2.props.onMouseOver(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleMouseLeave = function (e) {
	    if (_this2.props.onMouseLeave) {
	      _this2.props.onMouseLeave(e);
	    }
	
	    if (!_this2.props.disabled) {
	      _this2.setState({ active: false });
	    }
	  };
	
	  this._handleTouchStart = function (e) {
	    if (_this2.props.onTouchStart) {
	      _this2.props.onTouchStart(e);
	    }
	
	    _this2._touched = true;
	
	    _this2.setState({ active: true, touchedAt: Date.now() });
	  };
	
	  this._handleTouchEnd = function (e) {
	    if (_this2.props.onTouchEnd) {
	      _this2.props.onTouchEnd(e);
	    }
	
	    var time = Date.now() - _this2.state.touchedAt;
	    _this2._touchTimeout = setTimeout(function () {
	      _this2._touchTimeout = null;
	
	      _this2.setState({ active: false });
	    }, time > 450 ? 0 : 450 - time);
	  };
	
	  this._handleKeyUp = function (e) {
	    if (_this2.props.onKeyUp) {
	      _this2.props.onKeyUp(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.addEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: true });
	    }
	  };
	
	  this._handleKeyDown = function (e) {
	    if (_this2.props.onKeyDown) {
	      _this2.props.onKeyDown(e);
	    }
	
	    if ((e.which || e.keyCode) === _keyCodes.TAB) {
	      window.removeEventListener('click', _this2._handleOutsideClick);
	      _this2.setState({ active: false });
	    }
	  };
	};
	
	exports.default = ListItem;
	//# sourceMappingURL=ListItem.js.map

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(58);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `ListItemText` component is used to render the `primaryText` and an optional
	 * `secondaryText` for a `ListItem`.
	 */
	var ListItemText = function (_PureComponent) {
	  _inherits(ListItemText, _PureComponent);
	
	  function ListItemText() {
	    _classCallCheck(this, ListItemText);
	
	    return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
	  }
	
	  _createClass(ListItemText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          disabled = _props.disabled,
	          primaryText = _props.primaryText,
	          primaryTextStyle = _props.primaryTextStyle,
	          primaryTextClassName = _props.primaryTextClassName,
	          secondaryText = _props.secondaryText,
	          secondaryTextStyle = _props.secondaryTextStyle,
	          secondaryTextClassName = _props.secondaryTextClassName,
	          className = _props.className,
	          threeLines = _props.threeLines,
	          props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'primaryTextStyle', 'primaryTextClassName', 'secondaryText', 'secondaryTextStyle', 'secondaryTextClassName', 'className', 'threeLines']);
	
	      var secondaryTextNode = void 0;
	      if (secondaryText) {
	        secondaryTextNode = _react2.default.createElement(
	          'div',
	          {
	            style: secondaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--secondary', {
	              'md-tile-text--three-lines': threeLines
	            }, (0, _themeColors2.default)({ disabled: disabled, hint: !disabled }), secondaryTextClassName)
	          },
	          secondaryText
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: primaryTextStyle,
	            className: (0, _classnames2.default)('md-tile-text--primary', _defineProperty({}, activeClassName, !disabled && active), (0, _themeColors2.default)({ disabled: disabled, text: !active }), primaryTextClassName)
	          },
	          primaryText
	        ),
	        secondaryTextNode
	      );
	    }
	  }]);
	
	  return ListItemText;
	}(_react.PureComponent);
	
	ListItemText.propTypes = {
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  primaryText: _propTypes2.default.node.isRequired,
	  primaryTextStyle: _propTypes2.default.object,
	  primaryTextClassName: _propTypes2.default.string,
	  secondaryText: _propTypes2.default.node,
	  secondaryTextStyle: _propTypes2.default.object,
	  secondaryTextClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  threeLines: _propTypes2.default.bool
	};
	exports.default = ListItemText;
	//# sourceMappingURL=ListItemText.js.map

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `TileAddon` component is used to render either a `FontIcon` or an `Avatar`
	 * next to the `ListTileText` for a `ListItem`.
	 */
	var TileAddon = function (_PureComponent) {
	  _inherits(TileAddon, _PureComponent);
	
	  function TileAddon() {
	    _classCallCheck(this, TileAddon);
	
	    return _possibleConstructorReturn(this, (TileAddon.__proto__ || Object.getPrototypeOf(TileAddon)).apply(this, arguments));
	  }
	
	  _createClass(TileAddon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          avatar = _props.avatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          style = _props.style,
	          className = _props.className;
	
	      if (!icon && !avatar) {
	        return null;
	      }
	
	      var avatarIcon = false;
	      if (avatar) {
	        var avatarChild = _react2.default.Children.only(avatar);
	        if (avatarChild.props.iconSized) {
	          avatarIcon = true;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        {
	          style: style,
	          className: (0, _classnames2.default)('md-tile-addon', _defineProperty({
	            'md-tile-addon--icon': icon || avatarIcon,
	            'md-tile-addon--avatar': avatar && !avatarIcon
	          }, activeClassName, active), className)
	        },
	        icon || avatar
	      );
	    }
	  }]);
	
	  return TileAddon;
	}(_react.PureComponent);
	
	TileAddon.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  icon: _propTypes2.default.node,
	  avatar: _propTypes2.default.node
	};
	exports.default = TileAddon;
	//# sourceMappingURL=TileAddon.js.map

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(239);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _CSSTransitionGroupTick = __webpack_require__(56);
	
	var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	var _getField = __webpack_require__(28);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _handleKeyboardAccessibility = __webpack_require__(231);
	
	var _handleKeyboardAccessibility2 = _interopRequireDefault(_handleKeyboardAccessibility);
	
	var _anchorShape = __webpack_require__(146);
	
	var _anchorShape2 = _interopRequireDefault(_anchorShape);
	
	var _fixedToShape = __webpack_require__(98);
	
	var _fixedToShape2 = _interopRequireDefault(_fixedToShape);
	
	var _positionShape = __webpack_require__(222);
	
	var _positionShape2 = _interopRequireDefault(_positionShape);
	
	var _Layover = __webpack_require__(561);
	
	var _Layover2 = _interopRequireDefault(_Layover);
	
	var _List = __webpack_require__(99);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Menu` controlled component is used to display a list of children in the `List`
	 * component once the `visible` prop is true.
	 */
	var Menu = function (_PureComponent) {
	  _inherits(Menu, _PureComponent);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this._handleClose = function (e) {
	      var _this$props = _this.props,
	          close = _this$props.close,
	          onClose = _this$props.onClose;
	
	      if (close || onClose) {
	        (close || onClose)(e);
	      }
	    }, _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      var node = e.target;
	      while (_this._container && _this._container.contains(node)) {
	        if (_this._isIgnoreTarget(node)) {
	          return;
	        } else if (_this._isCloseTarget(node)) {
	          e.persist();
	          // set a timeout so item click events still trigger, and then close
	          _this._timeout = setTimeout(function () {
	            _this._timeout = null;
	            _this._handleClose(e);
	          }, _CSSTransitionGroupTick2.default);
	
	          return;
	        }
	
	        node = node.parentNode;
	      }
	    }, _this._handleKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	
	      (0, _handleKeyboardAccessibility2.default)(e, _this._handleClick, true, true);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Menu, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          cascading = _props.cascading,
	          id = _props.id,
	          fixedTo = _props.fixedTo,
	          cascadingAnchor = _props.cascadingAnchor;
	
	      var listLevel = this.context.listLevel || 0;
	      var cascadingMenu = typeof cascading !== 'undefined' ? cascading : this.context.cascadingMenu;
	      var cascadingZDepth = (0, _getField2.default)(this.context, this.props, 'cascadingZDepth');
	      var cascadingFixedTo = typeof fixedTo !== 'undefined' ? fixedTo : this.context.cascadingFixedTo;
	
	      return {
	        listLevel: listLevel,
	        cascadingId: id + '-level-' + (listLevel + 1),
	        cascadingMenu: cascadingMenu,
	        cascadingAnchor: cascadingAnchor,
	        cascadingZDepth: cascadingZDepth,
	        cascadingFixedTo: cascadingFixedTo
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._container = (0, _reactDom.findDOMNode)(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: '_isCloseTarget',
	
	
	    /**
	     * Checks if a provided event target or HTML Element is considered a menu click target.
	     * This normally is just a ListItem.
	     */
	    value: function _isCloseTarget(target) {
	      return target.classList.contains('md-list-item') && !target.classList.contains('md-list-item--nested-container');
	    }
	
	    /**
	     * Checks if a provided event target or HTML Element is something that should shortcut/break
	     * out of the click event loop because it **should not** close menus when clicked.
	     */
	
	  }, {
	    key: '_isIgnoreTarget',
	    value: function _isIgnoreTarget(target) {
	      return target.getAttribute('disabled') !== null || target.classList.contains('md-list-control');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cn;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          listStyle = _props2.listStyle,
	          listClassName = _props2.listClassName,
	          visible = _props2.visible,
	          children = _props2.children,
	          listProps = _props2.listProps,
	          listZDepth = _props2.listZDepth,
	          listInline = _props2.listInline,
	          listHeightRestricted = _props2.listHeightRestricted,
	          cascading = _props2.cascading,
	          sameWidth = _props2.sameWidth,
	          simplified = _props2.simplified,
	          contained = _props2.contained,
	          isOpen = _props2.isOpen,
	          propFixedTo = _props2.fixedTo,
	          propListId = _props2.listId,
	          cascadingAnchor = _props2.cascadingAnchor,
	          cascadingZDepth = _props2.cascadingZDepth,
	          onClose = _props2.onClose,
	          propPosition = _props2.position,
	          close = _props2.close,
	          autoclose = _props2.autoclose,
	          limitHeight = _props2.limitHeight,
	          expanderIconChildren = _props2.expanderIconChildren,
	          expanderIconClassName = _props2.expanderIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'className', 'listStyle', 'listClassName', 'visible', 'children', 'listProps', 'listZDepth', 'listInline', 'listHeightRestricted', 'cascading', 'sameWidth', 'simplified', 'contained', 'isOpen', 'fixedTo', 'listId', 'cascadingAnchor', 'cascadingZDepth', 'onClose', 'position', 'close', 'autoclose', 'limitHeight', 'expanderIconChildren', 'expanderIconClassName']);
	
	      var _props3 = this.props,
	          listId = _props3.listId,
	          position = _props3.position;
	
	      if (!listId) {
	        listId = id + '-list';
	      }
	
	      // can't have a simplified menu for cascading and context menus
	      var simple = !cascading && !props.onContextMenu && position !== 'context' && simplified;
	      if (position === 'context') {
	        position = Menu.Positions.BELOW;
	      }
	
	      var below = position === Menu.Positions.BELOW;
	      var fixedTo = typeof propFixedTo !== 'undefined' ? propFixedTo : this.context.cascadingFixedTo;
	      var listVisible = typeof isOpen !== 'undefined' ? isOpen : visible;
	      return _react2.default.createElement(
	        _Layover2.default,
	        _extends({}, props, {
	          id: id,
	          className: (0, _classnames2.default)('md-menu-container', {
	            'md-menu-container--menu-below': simplified && below
	          }, className),
	          simplified: simple,
	          sameWidth: contained || sameWidth,
	          fixedTo: fixedTo,
	          onClick: this._handleClick,
	          onKeyDown: this._handleKeyDown,
	          onClose: this._handleClose,
	          animationPosition: position,
	          visible: listVisible,
	          'aria-haspopup': true,
	          'aria-expanded': listVisible,
	          'aria-owns': listId
	        }),
	        _react2.default.createElement(
	          _List2.default,
	          _extends({}, listProps, {
	            id: listId,
	            key: 'menu-list',
	            style: listStyle,
	            className: (0, _classnames2.default)('md-list--menu', (_cn = {
	              'md-list--menu-restricted': listHeightRestricted,
	              'md-list--menu-contained': simplified && (sameWidth || contained)
	            }, _defineProperty(_cn, 'md-list--menu-' + position, simplified), _defineProperty(_cn, 'md-paper md-paper--' + listZDepth, listZDepth), _cn), listClassName),
	            inline: listInline
	          }),
	          children
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.PureComponent);
	
	Menu.HorizontalAnchors = _Layover2.default.HorizontalAnchors;
	Menu.VerticalAnchors = _Layover2.default.VerticalAnchors;
	Menu.Positions = {
	  // Can't do ...Layover.Positions since it triggers the get for CONTEXT
	  TOP_LEFT: _Layover2.default.Positions.TOP_LEFT,
	  TOP_RIGHT: _Layover2.default.Positions.TOP_RIGHT,
	  BOTTOM_LEFT: _Layover2.default.Positions.BOTTOM_LEFT,
	  BOTTOM_RIGHT: _Layover2.default.Positions.BOTTOM_RIGHT,
	  BELOW: _Layover2.default.Positions.BELOW,
	  _warned: false,
	  get CONTEXT() {
	    if (!this._warned) {
	      /* eslint-disable no-console */
	      console.error('The `Menu.Positions.CONTEXT` position has been deprecated and will be removed ' + 'in the next major release. To make the `Menu` behave as a context menu, provide ' + 'the `onContextMenu` prop instead.');
	      /* eslint-enable no-console */
	    }
	
	    this._warned = true;
	    return 'context';
	  }
	};
	Menu.propTypes = {
	  /**
	   * An id to provide to the menu's container. This is required for accessibility as it generates
	   * the `aria-` attributes for dynamic content.
	   *
	   * @see {@link #listId}
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional id to provide to the menu's list. If this prop is omitted, the list's id will be
	   * `\`${id}-list\``
	   */
	  listId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the main container for the menu.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the main container for the menu.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the list once the menu has opened.
	   */
	  listStyle: _propTypes2.default.object,
	
	  /**
	   * An optional class name to apply to the list once the menu has opened.
	   */
	  listClassName: _propTypes2.default.string,
	
	  /**
	   * The component to render the main container as.
	   *
	   * @see {@link Helpers/Layover#component}
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * This is how the menu's `List` gets anchored to the `toggle` element.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  anchor: _anchorShape2.default,
	
	  /**
	   * This is the optional anchor to use when the `position` is set to `Menu.Positions.BELOW`.
	   * Set this to `null` to use the default `anchor` prop.
	   *
	   * @see {@link Helpers/Layover#belowAnchor}
	   */
	  belowAnchor: _anchorShape2.default,
	
	  /**
	   * This is the animation position for the list that appears.
	   *
	   * @see {@link Helpers/Layover#animationPosition}
	   */
	  position: _positionShape2.default,
	
	  /**
	   * This is the component/element that should toggle the menu open.
	   *
	   * @see {@link Helpers/Layover#toggle}
	   */
	  toggle: _propTypes2.default.node,
	
	  /**
	   * This is how the menu's list will be "fixed" to the `toggle` component.
	   *
	   * @see {@link Helpers/Layover#fixedTo}
	   */
	  fixedTo: _fixedToShape2.default,
	
	  /**
	   * Any additional props that should be applied to the list in the menu. This is really used
	   * when additional `aria-` tags need to be applied.
	   */
	  listProps: _propTypes2.default.object,
	
	  /**
	   * Boolean if the menu's list should appear horizontally instead of vertically.
	   */
	  listInline: _propTypes2.default.bool,
	
	  /**
	   * The list's z-depth for applying box shadow. This should be a number from 0 to 5.
	   */
	  listZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the list should have its height restricted to the `$md-menu-mobile-max-height`/
	   * `$md-menu-desktop-max-height` values.
	   *
	   * @see [md-menu-mobile-max-height](/components/menus?tab=2#variable-md-menu-mobile-max-height)
	   * @see [md-menu-desktop-max-height](/components/menus?tab=2#variable-md-menu-desktop-max-height)
	   */
	  listHeightRestricted: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu's list is visible.
	   */
	  visible: _propTypes2.default.bool.isRequired,
	
	  /**
	   * Any children to render in the menu's list. This _should_ normally be `ListItem`, or
	   * `ListItemControl`.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * An optional function to call when en element in the menu has been clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * An optional function to call when a key is pressed anywhere in the menu.
	   */
	  onKeyDown: _propTypes2.default.func,
	
	  /**
	   * A function to call to close the menu. This is used for closing on outside clicks,
	   * closing when a list item has been clicked, or the user presses escape.
	   */
	  onClose: _propTypes2.default.func.isRequired,
	
	  /**
	   * Boolean if the menu should be cascading. This means that the menu will pop the additional
	   * `nestedItems` on any `ListItem` to be appear either to the right or left of the visible list.
	   */
	  cascading: _propTypes2.default.bool,
	
	  /**
	   * This is how the cascading lists get anchored to the list item.
	   *
	   * @see {@link Helpers/Layover#anchor}
	   */
	  cascadingAnchor: _Layover2.default.propTypes.anchor,
	
	  /**
	   * This is the z-depth the list should gain for a cascading menu. This only gets applied on
	   * items that are more than 1 level deep.
	   */
	  cascadingZDepth: _propTypes2.default.number.isRequired,
	
	  /**
	   * Boolean if the `md-full-width` class name should get applied to the menu's container.
	   */
	  fullWidth: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should be displayed as a block instead of as an inline block.
	   *
	   * @see {@link #fullWidth}
	   */
	  block: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#centered}
	   */
	  centered: _Layover2.default.propTypes.centered,
	
	  /**
	   * @see {@link Helpers/Layover#sameWidth}
	   */
	  sameWidth: _Layover2.default.propTypes.sameWidth,
	
	  /**
	   * If you would like the menu to interact as a context menu, provide this prop.
	   *
	   * @see {@link Helpers/Layover#onContextMenu}
	   */
	  onContextMenu: _Layover2.default.propTypes.onContextMenu,
	
	  /**
	   * Boolean if the default behavior of the context menu should be prevented when using the
	   * `onContextMenu` prop.
	   *
	   * @see {@link Helpers/Layover#preventContextMenu}
	   */
	  preventContextMenu: _Layover2.default.propTypes.preventContextMenu,
	
	  /**
	   * @see {@link Helpers/Layover#xThreshold}
	   */
	  xThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#yThreshold}
	   */
	  yThreshold: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#closeOnOutsideClick}
	   */
	  closeOnOutsideClick: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#toggleQuery}
	   */
	  toggleQuery: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]),
	
	  /**
	   * An optional transition name to use for the list appearing/disappearing.
	   *
	   * @see {@link Helpers/Layover#transitionName}
	   */
	  transitionName: _propTypes2.default.string,
	
	  /**
	   * @see {@link Helpers/Layover#transitionEnterTimeout}
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * @see {@link Helpers/Layover#transitionLeaveTimeout}
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the `fixedTo` element scrolls.
	   *
	   * @see {@link Helpers/Layover#repositionOnScroll}
	   */
	  repositionOnScroll: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the menu should automatically try to reposition itself to stay within
	   * the viewport when the window resizes.
	   *
	   * @see {@link Helpers/Layover#repositionOnResize}
	   */
	  repositionOnResize: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#simplified}
	   */
	  simplified: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#minLeft}
	   */
	  minLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minRight}
	   */
	  minRight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#minBottom}
	   */
	  minBottom: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportWidth}
	   */
	  fillViewportWidth: _propTypes2.default.bool,
	
	  /**
	   * @see {@link Helpers/Layover#fillViewportHeight}
	   */
	  fillViewportHeight: _propTypes2.default.bool,
	
	  isOpen: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `visible` instead'),
	  close: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onClose` instead'),
	  autoclose: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always autoclose as according to the specs'),
	  contained: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `sameWidth` instead'),
	  limitHeight: (0, _deprecated2.default)(_propTypes2.default.bool, 'The menus will always be limited in height as according to the specs'),
	  expanderIconClassName: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
	  expanderIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
	};
	Menu.defaultProps = {
	  anchor: {
	    x: _Layover2.default.HorizontalAnchors.INNER_RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  cascadingAnchor: {
	    x: _Layover2.default.HorizontalAnchors.RIGHT,
	    y: _Layover2.default.VerticalAnchors.OVERLAP
	  },
	  position: _Layover2.default.Positions.TOP_RIGHT,
	  fixedTo: typeof window !== 'undefined' ? window : {},
	  listZDepth: 2,
	  listHeightRestricted: true,
	  cascadingZDepth: 3,
	  repositionOnScroll: true,
	  repositionOnResize: false,
	  simplified: true
	};
	Menu.contextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	Menu.childContextTypes = {
	  listLevel: _propTypes2.default.number,
	  cascadingId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  cascadingMenu: _propTypes2.default.bool,
	  cascadingFixedTo: _fixedToShape2.default,
	  cascadingAnchor: _anchorShape2.default,
	  cascadingZDepth: _propTypes2.default.number
	};
	exports.default = Menu;
	//# sourceMappingURL=Menu.js.map

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(20);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A button used to close the persistent navigation drawer. The button will
	 * be generated based on the `NavigationDrawer`'s `contextTypes`.
	 *
	 * This component is really only used if you are using a `persistent` drawer and you
	 * manually created the `drawerHeader` for the `NavigationDrawer`.
	 */
	var CloseButton = function (_PureComponent) {
	  _inherits(CloseButton, _PureComponent);
	
	  function CloseButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CloseButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      if (_this.context.onCloseClick) {
	        _this.context.onCloseClick(e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CloseButton, [{
	    key: 'render',
	    value: function render() {
	      var closeIcon = this.context.closeIcon;
	
	
	      return _react2.default.createElement(_Button2.default, _extends({}, this.props, {
	        icon: true,
	        key: 'close',
	        onClick: this._handleClick,
	        iconEl: closeIcon
	      }));
	    }
	  }]);
	
	  return CloseButton;
	}(_react.PureComponent);
	
	CloseButton.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional additional function to call when the `click` event is triggered.
	   */
	  onClick: _propTypes2.default.func
	};
	CloseButton.contextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func
	};
	exports.default = CloseButton;
	//# sourceMappingURL=CloseButton.js.map

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This is an accessibility only component that should be used in the `NavigationDrawer`
	 * component. It allows keyboard users to quickly jump to the main content.
	 *
	 * This component relies on the `contextTypes` of the `NavigationDrawer` to work. If this is going
	 * to be used outside of that component, you will need to specify an `id` and `label` contextType
	 * to pass to this component.
	 */
	var JumpToContentLink = function (_PureComponent) {
	  _inherits(JumpToContentLink, _PureComponent);
	
	  function JumpToContentLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JumpToContentLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JumpToContentLink.__proto__ || Object.getPrototypeOf(JumpToContentLink)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	      if (_this.props.onClick) {
	        _this.props.onClick(e);
	      }
	
	      document.getElementById(_this.context.id).focus();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JumpToContentLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['className']);
	
	      var _context = this.context,
	          id = _context.id,
	          label = _context.label;
	
	      return _react2.default.createElement(
	        'a',
	        _extends({}, props, {
	          id: 'jump-to-' + id,
	          href: '#' + id,
	          onClick: this._handleClick,
	          className: (0, _classnames2.default)('md-content-jump', className)
	        }),
	        label
	      );
	    }
	  }]);
	
	  return JumpToContentLink;
	}(_react.PureComponent);
	
	JumpToContentLink.propTypes = {
	  /**
	   * An optional className to apply.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional function to call when the linked is clicked.
	   */
	  onClick: _propTypes2.default.func
	};
	JumpToContentLink.contextTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired
	};
	exports.default = JumpToContentLink;
	//# sourceMappingURL=JumpToContentLink.js.map

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccessibleFakeInkedButton = __webpack_require__(216);
	
	var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	var _TileAddon = __webpack_require__(224);
	
	var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MiniListItem = function (_PureComponent) {
	  _inherits(MiniListItem, _PureComponent);
	
	  function MiniListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MiniListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MiniListItem.__proto__ || Object.getPrototypeOf(MiniListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this._handleMouseOver = function (e) {
	      if (_this.props.onMouseOver) {
	        _this.props.onMouseOver(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: true });
	      }
	    }, _this._handleMouseLeave = function (e) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(e);
	      }
	
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this._handleTouchStart = function (e) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(e);
	      }
	
	      _this._touched = true;
	
	      _this.setState({ active: true, touchedAt: Date.now() });
	    }, _this._handleTouchEnd = function (e) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(e);
	      }
	
	      var time = Date.now() - _this.state.touchedAt;
	      _this._touchTimeout = setTimeout(function () {
	        _this._touchTimeout = null;
	
	        _this.setState({ active: false });
	      }, time > 450 ? 0 : 450 - time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MiniListItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._touchTimeout) {
	        clearTimeout(this._touchTimeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          tileStyle = _props.tileStyle,
	          tileClassName = _props.tileClassName,
	          leftIcon = _props.leftIcon,
	          leftAvatar = _props.leftAvatar,
	          active = _props.active,
	          activeClassName = _props.activeClassName,
	          ItemComponent = _props.itemComponent,
	          primaryText = _props.primaryText,
	          secondaryText = _props.secondaryText,
	          rightIcon = _props.rightIcon,
	          rightAvatar = _props.rightAvatar,
	          threeLines = _props.threeLines,
	          children = _props.children,
	          defaultOpen = _props.defaultOpen,
	          isOpen = _props.isOpen,
	          inset = _props.inset,
	          nestedItems = _props.nestedItems,
	          animateNestedItems = _props.animateNestedItems,
	          expanderIcon = _props.expanderIcon,
	          expanderIconChildren = _props.expanderIconChildren,
	          expanderIconClassName = _props.expanderIconClassName,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName', 'itemComponent', 'primaryText', 'secondaryText', 'rightIcon', 'rightAvatar', 'threeLines', 'children', 'defaultOpen', 'isOpen', 'inset', 'nestedItems', 'animateNestedItems', 'expanderIcon', 'expanderIconChildren', 'expanderIconClassName']);
	
	      return _react2.default.createElement(
	        ItemComponent,
	        { style: style, className: className },
	        _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            style: tileStyle,
	            className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
	              'md-list-tile--active': this.state.active && !this._touched
	            }, tileClassName),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd
	          }),
	          _react2.default.createElement(_TileAddon2.default, {
	            active: active,
	            activeClassName: activeClassName,
	            icon: leftIcon,
	            avatar: leftAvatar
	          })
	        )
	      );
	    }
	  }]);
	
	  return MiniListItem;
	}(_react.PureComponent);
	
	MiniListItem.propTypes = {
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  tileStyle: _propTypes2.default.object,
	  tileClassName: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  activeClassName: _propTypes2.default.string,
	  leftIcon: _propTypes2.default.node,
	  leftAvatar: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool,
	  onTouchStart: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  defaultOpen: _propTypes2.default.bool,
	  itemComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	MiniListItem.defaultProps = {
	  activeClassName: 'md-text--theme-primary',
	  component: 'div',
	  itemComponent: 'li'
	};
	exports.default = MiniListItem;
	//# sourceMappingURL=MiniListItem.js.map

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CSSTransitionGroup = __webpack_require__(108);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _isRequiredForA11y = __webpack_require__(239);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _getField = __webpack_require__(28);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _controlled = __webpack_require__(102);
	
	var _controlled2 = _interopRequireDefault(_controlled);
	
	var _invalidIf = __webpack_require__(149);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _Button = __webpack_require__(20);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Drawer = __webpack_require__(558);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _List = __webpack_require__(99);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Toolbar = __webpack_require__(575);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _FontIcon = __webpack_require__(26);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _getDeprecatedIcon = __webpack_require__(145);
	
	var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);
	
	var _isType = __webpack_require__(215);
	
	var _JumpToContentLink = __webpack_require__(226);
	
	var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);
	
	var _CloseButton = __webpack_require__(225);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _MiniListItem = __webpack_require__(569);
	
	var _MiniListItem2 = _interopRequireDefault(_MiniListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DrawerTypes = _Drawer2.default.DrawerTypes;
	
	
	function getNonMiniType(type) {
	  var pMini = DrawerTypes.PERSISTENT_MINI,
	      tMini = DrawerTypes.TEMPORARY_MINI;
	
	  if ([pMini, tMini].indexOf(type) === -1) {
	    return type;
	  }
	
	  return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
	}
	
	function toMiniListItem(item, index) {
	  if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      key = item.key,
	      itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);
	
	  if (divider || subheader) {
	    return null;
	  }
	
	  return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
	}
	
	/**
	 * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
	 * of the `Toolbar` component and the `Drawer` component. Any props that are not specifically
	 * listed below will be provided to the `Drawer` component. So if there are props on the `Drawer`
	 * that are not listed here, they will be passed along.
	 *
	 * The main benefit of using this component is that it will manage adding respective offset
	 * classes automatically for you to the content and the drawer. It will also manage using
	 * a mini drawer type for you.
	 */
	
	var NavigationDrawer = function (_PureComponent) {
	  _inherits(NavigationDrawer, _PureComponent);
	
	  _createClass(NavigationDrawer, null, [{
	    key: 'getCurrentMedia',
	
	
	    /**
	     * Determines the current media and returns an object containing matches for `mobile`, `tablet`, `desktop`,
	     * and the current drawer type. This expects a `props` object of the drawer.
	     *
	     * If this is used server side, it will default to only matching mobile.
	     *
	     * @param {Object=} props - The current drawer's prop shape to extract the mobile, tablet, and desktop type/min
	     *    widths. This defaults to the drawer's default props.
	     * @return {Object} an object containing the media matches and the current type to use for the drawer.
	     */
	    value: function getCurrentMedia() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;
	
	      var mobileType = props.mobileDrawerType,
	          tabletType = props.tabletDrawerType,
	          desktopType = props.desktopDrawerType,
	          constantType = props.constantDrawerType,
	          others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);
	
	      return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
	    }
	  }]);
	
	  function NavigationDrawer(props) {
	    _classCallCheck(this, NavigationDrawer);
	
	    var _this = _possibleConstructorReturn(this, (NavigationDrawer.__proto__ || Object.getPrototypeOf(NavigationDrawer)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var defaultMedia = props.defaultMedia,
	        defaultVisible = props.defaultVisible,
	        initialDrawerType = props.initialDrawerType;
	
	
	    _this.state = {
	      mobile: initialDrawerType || defaultMedia === 'mobile',
	      tablet: initialDrawerType || defaultMedia === 'tablet',
	      desktop: initialDrawerType || defaultMedia === 'desktop'
	    };
	
	    if (typeof props.drawerType === 'undefined') {
	      _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
	    }
	
	    var type = (0, _getField2.default)(props, _this.state, 'drawerType');
	
	    if (typeof props.visible === 'undefined') {
	      // The logic for determining the visibility is handled by the created mini drawer
	      _this.state.visible = (0, _isType.isPermanent)(type);
	      if (!_this.state.visible && typeof defaultVisible !== 'undefined') {
	        _this.state.visible = defaultVisible;
	      }
	    }
	    return _this;
	  }
	
	  _createClass(NavigationDrawer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          persistentIcon = _props.persistentIcon,
	          id = _props.contentId,
	          label = _props.jumpLabel,
	          persistentIconChildren = _props.persistentIconChildren,
	          persistentIconClassName = _props.persistentIconClassName,
	          closeIconChildren = _props.closeIconChildren,
	          closeIconClassName = _props.closeIconClassName;
	
	
	      return {
	        id: id,
	        label: label,
	        closeIcon: (0, _getDeprecatedIcon2.default)(closeIconClassName || persistentIconClassName, closeIconChildren || persistentIconChildren, persistentIcon),
	        onCloseClick: this._toggleVisibility,
	        renderNode: this.context.renderNode
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var nVisible = (0, _getField2.default)(nextProps, this.state, 'visible');
	      if (visible !== nVisible) {
	        this._animate(nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._timeout) {
	        clearTimeout(this._timeout);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          style = _props2.style,
	          className = _props2.className,
	          toolbarStyle = _props2.toolbarStyle,
	          toolbarClassName = _props2.toolbarClassName,
	          drawerStyle = _props2.drawerStyle,
	          drawerClassName = _props2.drawerClassName,
	          contentStyle = _props2.contentStyle,
	          contentClassName = _props2.contentClassName,
	          Content = _props2.contentComponent,
	          miniDrawerStyle = _props2.miniDrawerStyle,
	          miniDrawerClassName = _props2.miniDrawerClassName,
	          miniNavStyle = _props2.miniNavStyle,
	          miniNavClassName = _props2.miniNavClassName,
	          miniDrawerId = _props2.miniDrawerId,
	          miniNavItemsId = _props2.miniNavItemsId,
	          navItems = _props2.navItems,
	          children = _props2.children,
	          drawerId = _props2.drawerId,
	          drawerTitle = _props2.drawerTitle,
	          drawerZDepth = _props2.drawerZDepth,
	          drawerChildren = _props2.drawerChildren,
	          drawerHeaderChildren = _props2.drawerHeaderChildren,
	          drawerTransitionDuration = _props2.drawerTransitionDuration,
	          toolbarId = _props2.toolbarId,
	          toolbarTitle = _props2.toolbarTitle,
	          toolbarTitleMenu = _props2.toolbarTitleMenu,
	          toolbarTitleStyle = _props2.toolbarTitleStyle,
	          toolbarTitleClassName = _props2.toolbarTitleClassName,
	          toolbarActions = _props2.toolbarActions,
	          toolbarProminent = _props2.toolbarProminent,
	          toolbarProminentTitle = _props2.toolbarProminentTitle,
	          toolbarThemeType = _props2.toolbarThemeType,
	          toolbarSingleColor = _props2.toolbarSingleColor,
	          toolbarChildren = _props2.toolbarChildren,
	          toolbarZDepth = _props2.toolbarZDepth,
	          mobileType = _props2.mobileDrawerType,
	          tabletType = _props2.tabletDrawerType,
	          desktopType = _props2.desktopDrawerType,
	          transitionName = _props2.transitionName,
	          transitionEnterTimeout = _props2.transitionEnterTimeout,
	          transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	          extractMini = _props2.extractMini,
	          miniDrawerHeader = _props2.miniDrawerHeader,
	          miniDrawerChildren = _props2.miniDrawerChildren,
	          footer = _props2.footer,
	          includeDrawerHeader = _props2.includeDrawerHeader,
	          contentId = _props2.contentId,
	          contentProps = _props2.contentProps,
	          constantDrawerType = _props2.constantDrawerType,
	          temporaryIcon = _props2.temporaryIcon,
	          temporaryIconChildren = _props2.temporaryIconChildren,
	          temporaryIconClassName = _props2.temporaryIconClassName,
	          menuIconChildren = _props2.menuIconChildren,
	          menuIconClassName = _props2.menuIconClassName,
	          propDrawerType = _props2.drawerType,
	          propDrawerHeader = _props2.drawerHeader,
	          propRenderNode = _props2.renderNode,
	          jumpLabel = _props2.jumpLabel,
	          persistentIcon = _props2.persistentIcon,
	          onDrawerChange = _props2.onDrawerChange,
	          closeIconChildren = _props2.closeIconChildren,
	          closeIconClassName = _props2.closeIconClassName,
	          persistentIconChildren = _props2.persistentIconChildren,
	          persistentIconClassName = _props2.persistentIconClassName,
	          props = _objectWithoutProperties(_props2, ['id', 'style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'miniDrawerStyle', 'miniDrawerClassName', 'miniNavStyle', 'miniNavClassName', 'miniDrawerId', 'miniNavItemsId', 'navItems', 'children', 'drawerId', 'drawerTitle', 'drawerZDepth', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarId', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'toolbarZDepth', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType', 'temporaryIcon', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'drawerType', 'drawerHeader', 'renderNode', 'jumpLabel', 'persistentIcon', 'onDrawerChange', 'closeIconChildren', 'closeIconClassName', 'persistentIconChildren', 'persistentIconClassName']);
	
	      var drawerHeader = this.props.drawerHeader;
	      var _state = this.state,
	          desktop = _state.desktop,
	          tablet = _state.tablet,
	          contentActive = _state.contentActive;
	
	
	      var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
	      var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	      var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	      var mini = (0, _isType.isMini)(drawerType);
	      var temporary = (0, _isType.isTemporary)(drawerType);
	      var persistent = (0, _isType.isPersistent)(drawerType);
	      var clipped = drawerType === DrawerTypes.CLIPPED;
	      var floating = drawerType === DrawerTypes.FLOATING;
	
	      var offset = desktop || tablet ? !temporary && visible : visible;
	      var toolbarRelative = (0, _classnames2.default)({
	        'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
	        'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
	      });
	
	      var nav = void 0;
	      if (temporary || persistent) {
	        nav = _react2.default.createElement(_Button2.default, {
	          key: 'nav',
	          onClick: this._toggleVisibility,
	          disabled: persistent && visible,
	          icon: true,
	          iconEl: (0, _getDeprecatedIcon2.default)(menuIconClassName || temporaryIconClassName, menuIconChildren || temporaryIconChildren, temporaryIcon)
	        });
	      }
	
	      var closeButton = void 0;
	      if (persistent) {
	        closeButton = _react2.default.createElement(_CloseButton2.default, null);
	      }
	
	      if (!drawerHeader && includeDrawerHeader) {
	        drawerHeader = _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            key: 'drawer-header',
	            title: drawerTitle,
	            actions: visible && nav ? closeButton : null,
	            className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', _defineProperty({}, toolbarRelative, clipped || floating))
	          },
	          drawerHeaderChildren,
	          _react2.default.createElement(_JumpToContentLink2.default, null)
	        );
	      }
	      var miniDrawer = void 0;
	      if (mini) {
	        var miniList = void 0;
	        if (extractMini) {
	          miniList = _react2.default.createElement(
	            _List2.default,
	            {
	              id: miniNavItemsId,
	              key: 'mini-nav-items',
	              style: miniNavStyle,
	              className: (0, _classnames2.default)(miniNavClassName, toolbarRelative)
	            },
	            navItems.map(toMiniListItem)
	          );
	        }
	
	        miniDrawer = _react2.default.createElement(
	          _Drawer2.default,
	          {
	            id: miniDrawerId,
	            key: 'mini-drawer',
	            type: drawerType,
	            renderNode: renderNode,
	            'aria-hidden': visible,
	            style: miniDrawerStyle,
	            className: miniDrawerClassName
	          },
	          miniDrawerHeader,
	          miniList,
	          miniDrawerChildren
	        );
	      }
	
	      var desktopOffset = !clipped && !floating && offset;
	
	      return _react2.default.createElement(
	        'div',
	        { id: id, style: style, className: className },
	        _react2.default.createElement(
	          _Toolbar2.default,
	          {
	            id: toolbarId,
	            colored: toolbarThemeType === 'colored',
	            themed: toolbarThemeType === 'themed',
	            singleColor: toolbarSingleColor,
	            style: toolbarStyle,
	            className: (0, _classnames2.default)({
	              'md-toolbar--over-drawer': clipped || floating || mini && !visible
	            }, toolbarClassName),
	            title: toolbarTitle,
	            titleMenu: toolbarTitleMenu,
	            prominent: toolbarProminent,
	            prominentTitle: toolbarProminentTitle,
	            titleStyle: toolbarTitleStyle,
	            titleClassName: (0, _classnames2.default)({
	              'md-title--drawer-active': contentActive,
	              'md-transition--deceleration': offset && visible,
	              'md-transition--acceleration': offset && !visible,
	              'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
	              'md-title--persistent-offset': desktopOffset && persistent
	            }, toolbarTitleClassName),
	            nav: nav,
	            actions: toolbarActions,
	            fixed: true,
	            zDepth: toolbarZDepth
	          },
	          toolbarChildren
	        ),
	        miniDrawer,
	        _react2.default.createElement(
	          _Drawer2.default,
	          _extends({}, props, {
	            id: drawerId,
	            constantType: constantDrawerType,
	            transitionDuration: drawerTransitionDuration,
	            header: drawerHeader,
	            style: drawerStyle,
	            className: drawerClassName,
	            navItems: navItems,
	            renderNode: renderNode,
	            mobileType: mobileType,
	            tabletType: tabletType,
	            desktopType: desktopType,
	            type: getNonMiniType(drawerType),
	            visible: visible,
	            zDepth: drawerZDepth,
	            onVisibilityChange: this._handleVisibility,
	            onMediaTypeChange: this._handleTypeChange
	          }),
	          drawerChildren
	        ),
	        _react2.default.createElement(
	          _CSSTransitionGroup2.default,
	          _extends({}, contentProps, {
	            id: contentId,
	            component: Content,
	            transitionName: transitionName,
	            transitionEnter: !!transitionEnterTimeout,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeave: !!transitionLeaveTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout,
	            tabIndex: -1,
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-navigation-drawer-content', {
	              'md-navigation-drawer-content--active': contentActive,
	              'md-navigation-drawer-content--inactive': !visible,
	              'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
	              'md-transition--deceleration': visible,
	              'md-transition--acceleration': !visible,
	              'md-drawer-relative': offset,
	              'md-drawer-relative--mini': mini && (!visible || temporary)
	            }, toolbarRelative, contentClassName)
	          }),
	          children
	        ),
	        footer
	      );
	    }
	  }]);
	
	  return NavigationDrawer;
	}(_react.PureComponent);
	
	NavigationDrawer.DrawerType = { // deprecated
	  /* eslint-disable no-console */
	  _warned: false,
	  _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next major release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',
	
	  get FULL_HEIGHT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FULL_HEIGHT;
	  },
	
	  get CLIPPED() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.CLIPPED;
	  },
	
	  get FLOATING() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.FLOATING;
	  },
	
	  get PERSISTENT() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT;
	  },
	
	  get PERSISTENT_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.PERSISTENT_MINI;
	  },
	
	  get TEMPORARY() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY;
	  },
	
	  get TEMPORARY_MINI() {
	    if (!this._warned) {
	      console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
	    }
	    this._warned = true;
	
	    return DrawerTypes.TEMPORARY_MINI;
	  }
	};
	NavigationDrawer.DrawerTypes = DrawerTypes;
	NavigationDrawer.propTypes = {
	  /**
	   * An optional id to provide to the entire div wrapper.
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the drawer. This is generally a good idea to provide if
	   * there are any `navItems` defined.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  drawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the navItems list. If this is omitted and the `drawerId` prop is
	   * defined, it will be defaulted to `${drawerId}-nav-items`.
	   *
	   * @see {@link #drawerId}
	   * @see {@link Drawer#navItemsId}
	   */
	  navItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer that gets created when the `drawerType` is set to
	   * one of the mini types.
	   *
	   * @see {@link #drawerId}
	   * @see {@link #miniNavItemsId}
	   */
	  miniDrawerId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to apply to mini drawer's navigation list that gets created when the `drawerType`
	   * is set to one of the mini types.
	   *
	   * @see {@link #navItemsId}
	   * @see {@link #miniDrawerId}
	   */
	  miniNavItemsId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional id to provide to the main toolbar.
	   */
	  toolbarId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
	   * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
	   *
	   * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
	   */
	  contentId: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	
	  /**
	   * An optional style to apply to the surrounding container.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the surrounding container.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar.
	   */
	  toolbarStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar.
	   */
	  toolbarClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the main toolbar's title.
	   */
	  toolbarTitleStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the main toolbar's title.
	   */
	  toolbarTitleClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the drawer.
	   */
	  drawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the drawer.
	   */
	  drawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the `List` surrounding the `navItems`.
	   */
	  navStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the `List` surrounding the `navItems`.
	   */
	  navClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer that gets created when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniNavStyle}
	   * @see {@link #miniNavClassName}
	   */
	  miniDrawerClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavClassName}
	   */
	  miniNavStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the mini drawer's navigation list when the `drawerType` is set
	   * to one of the mini types.
	   *
	   * @see {@link #miniDrawerStyle}
	   * @see {@link #miniDrawerClassName}
	   * @see {@link #miniNavStyle}
	   */
	  miniNavClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the content. This is the container surrounding whatever
	   * `children` are passed in.
	   */
	  contentClassName: _propTypes2.default.string,
	
	  /**
	   * An optional style to apply to the overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the overlay.
	   */
	  overlayClassName: _propTypes2.default.string,
	
	  /**
	   * The children to display in the main content.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
	   * passed in.
	   */
	  includeDrawerHeader: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the drawer. This will normally be the `Toolbar` component
	   * or any other type of header. You can either use this prop with the `CloseButton` component
	   * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
	   * to build a toolbar.
	   */
	  drawerHeader: _propTypes2.default.node,
	
	  /**
	   * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * An optional zDepth to apply to the drawer. If this is omitted, the value will be set as follows:
	   * - floating || inline = 1
	   * - temporary = 5
	   * - all others = 1
	   *
	   * @see {@link Papers/Paper#zDepth}
	   */
	  drawerZDepth: _propTypes2.default.number,
	
	  /**
	   * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
	   */
	  drawerChildren: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
	   * this is invalid.
	   */
	  drawerHeaderChildren: (0, _invalidIf2.default)(_propTypes2.default.node, 'drawerHeader'),
	
	  /**
	   * The position for the drawer to be displayed.
	   */
	  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * An optional list of elements or props to use to build a navigational list in the drawer.
	   * When the item is an object of props, it will build a `ListItem` component unless a key of
	   * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
	   * with any other remaining keys.
	   */
	  navItems: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.shape({
	    divider: _propTypes2.default.bool,
	    subheader: _propTypes2.default.bool,
	    primaryText: _propTypes2.default.node
	  })])),
	
	  /**
	   * The drawer type to use for mobile devices.
	   */
	  mobileDrawerType: _propTypes2.default.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for tablets.
	   */
	  tabletDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * The drawer type to use for desktop displays.
	   */
	  desktopDrawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	  /**
	   * An optional drawer type to enforce on all screen sizes. If the drawer type is not
	   * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
	   * to temporary when the media matches a mobile device.
	   * ```
	   */
	  drawerType: _propTypes2.default.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),
	
	  /**
	   * The default media match for the drawer. This will be what is displayed on first render.
	   * The component will adjust itself to the current media after it has mounted, but this
	   * is mostly used for server side rendering.
	   */
	  defaultMedia: _propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']),
	
	  /**
	   * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
	   * variable.
	   *
	   * The media query for a mobile device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  mobileMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(
	   *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
	   * ).matches;
	   * ```
	   */
	  tabletMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
	   * variable.
	   *
	   * The media query for a tablet device will be:
	   *
	   * ```js
	   * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
	   * ```
	   */
	  desktopMinWidth: _propTypes2.default.number.isRequired,
	
	  /**
	   * An optional function to call when the type of the drawer changes because of the
	   * new media queries. The callback will include the newly selected drawer type
	   * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
	   *
	   * ```js
	   * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
	   *   mobile: true,
	   *   tablet: false,
	   *   desktop: false,
	   * });
	   * ```
	   */
	  onMediaTypeChange: _propTypes2.default.func,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible by default.
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the temporary or persistent drawers are visible. If this is defined,
	   * it will make the component controlled and require the `onVisibilityChange` prop
	   * to be defined.
	   */
	  visible: (0, _controlled2.default)(_propTypes2.default.bool, 'onVisibilityChange', 'defaultVisible'),
	
	  /**
	   * An optional function to call when the visibility of the drawer changes. The callback
	   * will include the new visibility.
	   *
	   * ```js
	   * onVisibilityChange(false);
	   * ```
	   */
	  onVisibilityChange: _propTypes2.default.func,
	
	  /**
	   * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
	   * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
	   * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
	   *
	   *
	   * @see {@link #miniDrawerHeader}
	   * @see {@link #miniDrawerChildren}
	   */
	  extractMini: _propTypes2.default.bool,
	
	  /**
	   * An optional header to display in the mini drawer. This will be displayed above the optional
	   * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerHeader: _propTypes2.default.node,
	
	  /**
	   * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
	   * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
	   *
	   * @see {@link #extractMini}
	   */
	  miniDrawerChildren: _propTypes2.default.node,
	
	  /**
	   * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
	   */
	  autoclose: _propTypes2.default.bool,
	
	  /**
	   * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitle: (0, _invalidIf2.default)(_propTypes2.default.node, 'toolbarTitleMenu'),
	
	  /**
	   * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	   * may be defined, not both.
	   */
	  toolbarTitleMenu: _propTypes2.default.element,
	
	  /**
	   * The theme style for the main toolbar.
	   *
	   * @see {@link Toolbars/Toolbar}
	   */
	  toolbarThemeType: _propTypes2.default.oneOf(['default', 'colored', 'themed']).isRequired,
	
	  /**
	   * Boolean if the toolbar's nav, actions, and title should share the same color.
	   */
	  toolbarSingleColor: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar should be prominent.
	   */
	  toolbarProminent: _propTypes2.default.bool,
	
	  /**
	   * A boolean if the toolbar's title should be prominent.
	   */
	  toolbarProminentTitle: _propTypes2.default.bool,
	
	  /**
	   * A list of elements or a single element to display to the right of the
	   * toolbar's nav, title, and children.
	   *
	   * @see {@link Toolbars/Toolbar#actions}
	   */
	  toolbarActions: _Toolbar2.default.propTypes.actions,
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  toolbarChildren: _Toolbar2.default.propTypes.children,
	
	  /**
	   * An optional zDepth to apply to the toolbar.
	   *
	   * @see {@link Toolbars/Toolbar#zDepth}
	   */
	  toolbarZDepth: _propTypes2.default.number,
	
	  /**
	   * The component to render the content in.
	   */
	  contentComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * An optional footer display after the main content.
	   */
	  footer: _propTypes2.default.node,
	
	  /**
	   * The icon to use to render the button that will toggle the visibility of the
	   * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	   * hamburger menu.
	   */
	  temporaryIcon: _propTypes2.default.element,
	
	  /**
	   * The icon to use to render the button that appears on a persistent drawer's open
	   * header. This is used to create the `CloseButton` for drawers. When a persistent
	   * drawer is closed, the `temporaryIcon` will be used to create a button to open the drawer.
	   *
	   * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	   * in your header manually, or create your own controlled button to close the drawer.
	   */
	  persistentIcon: _propTypes2.default.element,
	
	  /**
	   * The transition name to use when the page's content changes. If you want to disable
	   * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
	   * to a false-ish value. (`null`, `undefined`, or `0`).
	   */
	  transitionName: _propTypes2.default.string.isRequired,
	
	  /**
	   * The transition enter timeout when the page's content changes. If you want to disable
	   * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionEnterTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition leave timeout when the page's content changes. If you want to disable
	   * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	   */
	  transitionLeaveTimeout: _propTypes2.default.number,
	
	  /**
	   * The transition duration for the drawer when sliding in and out of view.
	   */
	  drawerTransitionDuration: _propTypes2.default.number.isRequired,
	
	  /**
	   * Any additional props to provide to the main content. This will be applied before any of the generated props,
	   * so this should not include `style`, `className`, or `component`.
	   */
	  contentProps: _propTypes2.default.object,
	
	  /**
	   * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
	   * the main content. This is created in the drawer's header.
	   */
	  jumpLabel: _propTypes2.default.node.isRequired,
	
	  /**
	   * Boolean if the Portal's functionality of rendering in a separate react tree should be applied
	   * to the drawer. The overlay that appears for temporary type drawers will still appear in the
	   * separate subtree.
	   *
	   * @see {@link Helpers/Portal}
	   */
	  portal: _propTypes2.default.bool,
	
	  /**
	   * An optional DOM Node to render the drawer into. The default is to render as
	   * the first child in the `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  renderNode: _propTypes2.default.object,
	
	  /**
	   * Boolean if the drawer should be rendered as the last child instead of the first child
	   * in the `renderNode` or `body`.
	   *
	   * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	   * since the `Portal` component will not be used.
	   */
	  lastChild: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the `drawerType` should remain constant across all media. This is really only valid
	   * if the `drawerType` is one of the temporary types.
	   */
	  constantDrawerType: _propTypes2.default.bool,
	
	  menuIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `temporaryIcon` instead'),
	  menuIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `temporaryIcon` instead'),
	  closeIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use `persistentIcon` instead'),
	  closeIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `persistentIcon` instead'),
	  temporaryIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `temporaryIcon` instead'),
	  temporaryIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `temporaryIcon` instead'),
	  persistentIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `persistentIcon` instead'),
	  persistentIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `persistentIcon` prop instead'),
	  onDrawerChange: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` or `onMediaTypeChange` instead'),
	  onVisibilityToggle: (0, _deprecated2.default)(_propTypes2.default.func, 'Use `onVisibilityChange` instead'),
	  contentTransitionName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use `transitionName` instead'),
	  contentTransitionEnterTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionEnterTimeout` instead'),
	  contentTransitionLeaveTimeout: (0, _deprecated2.default)(_propTypes2.default.number, 'Use `transtionLeaveTimeout` instead'),
	  initialDrawerType: (0, _deprecated2.default)(_propTypes2.default.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
	};
	NavigationDrawer.contextTypes = {
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.childContextTypes = {
	  closeIcon: _propTypes2.default.element,
	  onCloseClick: _propTypes2.default.func,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  label: _propTypes2.default.node.isRequired,
	  renderNode: _propTypes2.default.object
	};
	NavigationDrawer.defaultProps = {
	  autoclose: _Drawer2.default.defaultProps.autoclose,
	  contentId: 'main-content',
	  // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
	  // controlled. On initial mount without any defaultMedia updates, it would always be considered
	  // temporary
	  constantDrawerType: false,
	  jumpLabel: 'Jump to content',
	  extractMini: true,
	  position: _Drawer2.default.defaultProps.position,
	  defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
	  mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
	  tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
	  desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
	  mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
	  tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
	  desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
	  includeDrawerHeader: true,
	  contentComponent: 'main',
	  temporaryIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'menu'
	  ),
	  toolbarThemeType: 'colored',
	  persistentIcon: _react2.default.createElement(
	    _FontIcon2.default,
	    null,
	    'arrow_back'
	  ),
	  transitionName: 'md-cross-fade',
	  transitionEnterTimeout: 300,
	  drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this._animate = function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.props;
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state;
	
	    if ((0, _isType.isTemporary)((0, _getField2.default)(props, state, 'drawerType'))) {
	      return;
	    }
	
	    if (_this2._timeout) {
	      clearTimeout(_this2._timeout);
	    }
	
	    _this2._timeout = setTimeout(function () {
	      _this2.setState({ contentActive: false });
	    }, props.drawerTransitionDuration);
	
	    _this2.setState({ contentActive: true });
	  };
	
	  this._toggleVisibility = function (e) {
	    var _props3 = _this2.props,
	        onVisibilityToggle = _props3.onVisibilityToggle,
	        onVisibilityChange = _props3.onVisibilityChange,
	        onDrawerChange = _props3.onDrawerChange;
	
	    var visible = !(0, _getField2.default)(_this2.props, _this2.state, 'visible');
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible, e);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleVisibility = function (visible) {
	    var _props4 = _this2.props,
	        onVisibilityToggle = _props4.onVisibilityToggle,
	        onVisibilityChange = _props4.onVisibilityChange,
	        onDrawerChange = _props4.onDrawerChange;
	
	    var callback = onVisibilityChange || onVisibilityToggle || onDrawerChange;
	    if (callback) {
	      callback(visible);
	    }
	
	    if (typeof _this2.props.visible === 'undefined') {
	      _this2.setState({ visible: visible });
	      _this2._animate(_this2.props);
	    }
	  };
	
	  this._handleTypeChange = function (drawerType, mediaState) {
	    var onMediaTypeChange = _this2.props.onMediaTypeChange;
	
	    var state = mediaState;
	    if (onMediaTypeChange) {
	      onMediaTypeChange(drawerType, mediaState);
	    }
	
	    if (typeof _this2.props.drawerType === 'undefined') {
	      state = _extends({}, mediaState, { drawerType: drawerType });
	    }
	
	    _this2.setState(state);
	  };
	};
	
	exports.default = NavigationDrawer;
	//# sourceMappingURL=NavigationDrawer.js.map

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;
	
	var _NavigationDrawer2 = __webpack_require__(570);
	
	var _NavigationDrawer3 = _interopRequireDefault(_NavigationDrawer2);
	
	var _CloseButton2 = __webpack_require__(225);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _JumpToContentLink2 = __webpack_require__(226);
	
	var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavigationDrawer3.default;
	exports.NavigationDrawer = _NavigationDrawer3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.JumpToContentLink = _JumpToContentLink3.default;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _themeColors = __webpack_require__(58);
	
	var _themeColors2 = _interopRequireDefault(_themeColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `Subheader` component is generally used inside of lists or menus.
	 */
	var Subheader = function (_PureComponent) {
	  _inherits(Subheader, _PureComponent);
	
	  function Subheader() {
	    _classCallCheck(this, Subheader);
	
	    return _possibleConstructorReturn(this, (Subheader.__proto__ || Object.getPrototypeOf(Subheader)).apply(this, arguments));
	  }
	
	  _createClass(Subheader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          inset = _props.inset,
	          primary = _props.primary,
	          primaryText = _props.primaryText,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        _extends({}, props, {
	          className: (0, _classnames2.default)('md-subheader', {
	            'md-list-item--inset': inset
	          }, (0, _themeColors2.default)({ primary: primary, hint: !primary }), className)
	        }),
	        primaryText,
	        children
	      );
	    }
	  }]);
	
	  return Subheader;
	}(_react.PureComponent);
	
	Subheader.propTypes = {
	  /**
	   * An optional style to apply to the subheader.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the subheader.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Boolean if the subheader should be styled with the primary color.
	   */
	  primary: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the subheader is inset in the list. This will add additional
	   * spacing to align the subheader.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * The primary text to use in the subheader.
	   */
	  primaryText: _propTypes2.default.node.isRequired,
	
	  /**
	   * Any optional children to display after the `primaryText`. This prop is
	   * not recommended.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * The component to render the Subheader as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	Subheader.defaultProps = {
	  component: 'li'
	};
	exports.default = Subheader;
	//# sourceMappingURL=Subheader.js.map

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Subheader = undefined;
	
	var _Subheader2 = __webpack_require__(229);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader3.default;
	exports.Subheader = _Subheader3.default;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deprecated = __webpack_require__(13);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _invalidIf = __webpack_require__(149);
	
	var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	var _between = __webpack_require__(234);
	
	var _between2 = _interopRequireDefault(_between);
	
	var _Paper = __webpack_require__(147);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ToolbarTitle = __webpack_require__(576);
	
	var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_PureComponent) {
	  _inherits(Toolbar, _PureComponent);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className,
	          component = _props.component,
	          titleStyle = _props.titleStyle,
	          titleClassName = _props.titleClassName,
	          prominentTitle = _props.prominentTitle,
	          themed = _props.themed,
	          singleColor = _props.singleColor,
	          actions = _props.actions,
	          fixed = _props.fixed,
	          children = _props.children,
	          inset = _props.inset,
	          titleId = _props.titleId,
	          propNav = _props.nav,
	          propTitle = _props.title,
	          propTitleMenu = _props.titleMenu,
	          propZDepth = _props.zDepth,
	          propColored = _props.colored,
	          propProminent = _props.prominent,
	          containerStyle = _props.containerStyle,
	          containerClassName = _props.containerClassName,
	          actionLeft = _props.actionLeft,
	          actionsRight = _props.actionsRight,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'themed', 'singleColor', 'actions', 'fixed', 'children', 'inset', 'titleId', 'nav', 'title', 'titleMenu', 'zDepth', 'colored', 'prominent', 'containerStyle', 'containerClassName', 'actionLeft', 'actionsRight', 'primary', 'secondary']);
	
	      var _props2 = this.props,
	          colored = _props2.colored,
	          title = _props2.title,
	          titleMenu = _props2.titleMenu,
	          nav = _props2.nav,
	          prominent = _props2.prominent,
	          zDepth = _props2.zDepth;
	
	
	      colored = colored || primary || secondary;
	      prominent = prominent || prominentTitle;
	
	      title = _react2.default.createElement(_ToolbarTitle2.default, {
	        key: 'title',
	        style: titleStyle,
	        className: titleClassName,
	        prominent: prominentTitle,
	        offset: prominentTitle,
	        id: typeof titleId === 'undefined' && props.id ? props.id + '-title' : titleId,
	        title: title
	      });
	
	      if (nav || actionLeft) {
	        var navEl = _react.Children.only(nav || actionLeft);
	        nav = (0, _react.cloneElement)(nav, {
	          className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
	        });
	      }
	
	      var rightActions = void 0;
	      if (actions || actionsRight) {
	        rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
	          return (0, _react.cloneElement)(action, {
	            className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
	          });
	        });
	
	        rightActions = _react2.default.createElement(
	          'div',
	          { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
	          rightActions
	        );
	      }
	
	      if (titleMenu) {
	        titleMenu = _react.Children.only(titleMenu);
	        titleMenu = (0, _react.cloneElement)(titleMenu, {
	          className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
	            'md-title--toolbar-offset': prominentTitle,
	            'md-title--toolbar-prominent': prominentTitle
	          }, titleMenu.props.className),
	          position: titleMenu.props.position || 'tl',
	          toolbar: true
	        });
	      }
	
	      if (typeof zDepth !== 'number') {
	        zDepth = fixed ? 2 : 0;
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, props, {
	          component: component,
	          zDepth: zDepth,
	          style: style,
	          className: (0, _classnames2.default)('md-toolbar', {
	            'md-background--primary': colored,
	            'md-toolbar--themed': themed,
	            'md-toolbar--text-white': singleColor && colored,
	            'md-toolbar--prominent': prominent,
	            'md-toolbar--fixed': fixed,
	            'md-toolbar--inset': inset
	          }, className)
	        }),
	        nav,
	        title,
	        titleMenu,
	        children,
	        rightActions
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.PureComponent);
	
	Toolbar.propTypes = {
	  /**
	   * An optional id to provide to the toolbar. If this is specified and the `titleId` is not, the title
	   * will gain an id of `${id}-title`. This will not be applied to the `titleMenu`.
	   *
	   * @see {@link #titleId}
	   */
	  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional style to apply to the toolbar.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * An optional className to apply to the toolbar,
	   */
	  className: _propTypes2.default.string,
	
	  /*
	   * An optional style to apply to the `h2` surrounding the `title` prop.
	   */
	  titleStyle: _propTypes2.default.object,
	
	  /*
	   * An optional className to apply to the `h2` surrounding the `title` prop.
	   */
	  titleClassName: _propTypes2.default.string,
	
	  /**
	   * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
	   */
	  prominent: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar's title should be more prominent. This will move the title to the
	   * second line of the toolbar. This only works when the `prominent` prop is true as well.
	   */
	  prominentTitle: _propTypes2.default.bool,
	
	  /**
	   * The current title of the page to show in the toolbar. It is invalid to specify both a
	   * `title` and a `titleMenu`. Only one should be given.
	   */
	  title: (0, _invalidIf2.default)(_propTypes2.default.node, 'titleMenu'),
	
	  /**
	   * An optional id to give the main title in the toolbar. This will not be applied to the
	   * `titleMenu`.
	   */
	  titleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * An optional title menu to display instead of the title. This should be a `SelectField` component.
	   * It is cloned with some additional props, so if the `SelectField` is separated into a separate
	   * component, the following props must be passed to get the correct styling: `className`, `block`,
	   * `paddedBlock`, `position`.
	   */
	  titleMenu: _propTypes2.default.element,
	
	  /**
	   * This prop is used for rendering an optional navigation button to the left of the `title`
	   * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
	   * are cloned into it.
	   */
	  nav: _propTypes2.default.element,
	
	  /**
	   * Any additional actions to display to the right of the title. This should be a list or a single
	   * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
	   */
	  actions: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
	
	  /**
	   * Any children to display in the toolbar. This will be displayed between the optional title and
	   * actions.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
	   */
	  fixed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
	   * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
	   * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
	   * stated above.
	   */
	  singleColor: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored based off the current theme. This will either style the background
	   * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
	   */
	  themed: _propTypes2.default.bool,
	
	  /**
	   * Boolean if the toolbar should be colored with the `$md-primary-color`.
	   */
	  colored: (0, _invalidIf2.default)(_propTypes2.default.bool, 'themed'),
	
	  /**
	   * The component to render the toolbar as.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	
	  /**
	   * Boolean if the toolbar is inset in the page. This will just add some margin around
	   * it.
	   */
	  inset: _propTypes2.default.bool,
	
	  /**
	   * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
	   * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
	   */
	  zDepth: (0, _between2.default)(_propTypes2.default.number, 0, 5),
	  containerStyle: (0, _deprecated2.default)(_propTypes2.default.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
	  containerClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
	  primary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use the `colored` prop instead'),
	  secondary: (0, _deprecated2.default)(_propTypes2.default.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
	  actionLeft: (0, _deprecated2.default)(_propTypes2.default.element, 'Use the `nav` prop instead'),
	  actionsRight: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `menu` prop and/or the `actions` prop instead')
	};
	Toolbar.defaultProps = {
	  singleColor: true,
	  component: 'header'
	};
	exports.default = Toolbar;
	//# sourceMappingURL=Toolbar.js.map

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarTitle = function (_PureComponent) {
	  _inherits(ToolbarTitle, _PureComponent);
	
	  function ToolbarTitle() {
	    _classCallCheck(this, ToolbarTitle);
	
	    return _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).apply(this, arguments));
	  }
	
	  _createClass(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          className = _props.className,
	          prominent = _props.prominent,
	          offset = _props.offset,
	          props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);
	
	      if (!title) {
	        return null;
	      }
	
	      var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
	        'md-title--toolbar-prominent': prominent,
	        'md-title--toolbar-offset': offset
	      }, className);
	
	      if ((0, _react.isValidElement)(title)) {
	        var titleEl = _react.Children.only(title);
	        return (0, _react.cloneElement)(title, _extends({}, props, {
	          id: titleEl.props.id || props.id,
	          className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
	        }));
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, props, {
	          className: fullClassName
	        }),
	        title
	      );
	    }
	  }]);
	
	  return ToolbarTitle;
	}(_react.PureComponent);
	
	ToolbarTitle.propTypes = {
	  className: _propTypes2.default.string,
	  prominent: _propTypes2.default.bool,
	  offset: _propTypes2.default.bool,
	  title: _propTypes2.default.node
	};
	exports.default = ToolbarTitle;
	//# sourceMappingURL=ToolbarTitle.js.map

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
	var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
	var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
	//# sourceMappingURL=media.js.map

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleKeyboardAccessibility;
	
	var _keyCodes = __webpack_require__(43);
	
	var _closest = __webpack_require__(592);
	
	var _closest2 = _interopRequireDefault(_closest);
	
	var _isFormPartRole = __webpack_require__(237);
	
	var _isFormPartRole2 = _interopRequireDefault(_isFormPartRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A utility function for adding keyboard accessibility to elements that are not a natively
	 * clickable (div, span, etc). When the space or enter key is pressed while focusing the
	 * element, different flows will happen.
	 *
	 * - space - The click event will be triggered and the default page scrolling behavior of the
	 *      spacebar will be prevented
	 * - enter - If the element has a form role ('checkbox' or 'radio'), the click event will not
	 *      be triggered. Instead, it will find out if the element is inside a form. If it is, it
	 *      will emulate the default behavior of attempting to submit the form. If the element does
	 *      not have a form role, the click event will be triggered.
	 *
	 * @param {Event} e - the keydown event
	 * @param {function} onClick - the on click event to be triggered if space or enter was pressed
	 * @param {boolean=true} listenToEnter - boolean if the enter key should be used to trigger the
	 *      the click event. Even if this is true, the click event will not be triggered if the role
	 *      is for a form role.
	 * @param {boolean=true} listenToSpace - boolean if the space key should be used to trigger the
	 *      click event.
	 * @return {Boolean} true if the enter or space keys were pressed while their listener is also active.
	 */
	function handleKeyboardAccessibility(e, onClick) {
	  var listenToEnter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var listenToSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  var key = e.which || e.keyCode;
	  var space = listenToSpace && key === _keyCodes.SPACE;
	  var enter = key === _keyCodes.ENTER;
	
	  var tagName = e.target.tagName;
	  // it is valid to press space in text fields, contenteditable, and buttons
	
	  if (space && !tagName.match(/input|textarea|button/i) && e.target.getAttribute('contenteditable') !== 'true') {
	    // Stop page scrolling
	    e.preventDefault();
	  }
	
	  if (enter && (0, _isFormPartRole2.default)(e.target)) {
	    var form = (0, _closest2.default)(e.target, 'form');
	    var submit = form ? form.querySelector('*[type="submit"]') : null;
	    if (submit) {
	      submit.click();
	    }
	
	    return true;
	  }
	
	  if (enter && listenToEnter || space) {
	    onClick(e);
	
	    return true;
	  }
	
	  return false;
	} /** @module utils/EventUtils/handleKeyboardAccessibility */
	//# sourceMappingURL=handleKeyboardAccessibility.js.map

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleWindowClickListeners;
	/** @module utils/EventUtils/handleWindowClickListeners */
	var mobileSafari = void 0;
	
	/**
	 * Since mobile safari doesn't delegate click events to the window (it only does touch events),
	 * this utility function will hack a fix to allow the delegation by updaging the body's cursor
	 * to be a pointer.
	 *
	 * Hopefully this can be removed one day....
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
	 * @param {function} cb - the callback function to use for a window click event.
	 * @param {boolean} enabled - boolean if the click event is enabled.
	 */
	function handleWindowClickListeners(cb) {
	  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof mobileSafari === 'undefined' && typeof window !== 'undefined') {
	    var ua = window.navigator.userAgent;
	    var iOS = ua.match(/iP(ad|hone)/i);
	    var webkit = ua.match(/WebKit/i);
	    mobileSafari = iOS && webkit && !ua.match(/CriOS/i);
	
	    if (mobileSafari) {
	      document.body.style.cursor = 'pointer';
	    }
	  }
	
	  var listener = window[(enabled ? 'add' : 'remove') + 'EventListener'];
	  listener('click', cb);
	}
	//# sourceMappingURL=handleWindowClickListeners.js.map

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScreenSize;
	/** @module utils/Positioning/getScreenSize */
	
	/**
	 * A utility function to get the height or width of the of the browser with
	 * a fallback for older browsers.
	 *
	 * @param {String} position - the position to get the screen size for
	 * @return {number} the screen size for the provided position.
	 */
	function getScreenSize(position) {
	  if (position !== 'Height' && position !== 'Width' && ("production") !== 'production') {
	    throw new Error('The \'getScreenSize\' function requires either a position of \'Height\' or \'Width\' ' + ('but received `' + position + '`'));
	  }
	
	  return window['inner' + position] || document.documentElement['client' + position];
	}
	//# sourceMappingURL=getScreenSize.js.map

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScroll;
	/** @module utils/Positioning/getScroll */
	
	/**
	 * A utility function to just get an element's scroll x and y
	 * values. This is really just needed because `window` uses
	 * different attributes.
	 *
	 * @param {Object} el - The element to get a scroll value from.
	 * @return {Object} an object containing the scrollX and scrollY of the element.
	 */
	function getScroll(el) {
	  if (typeof el.scrollX !== 'undefined' && typeof el.scrollY !== 'undefined') {
	    return { x: el.scrollX, y: el.scrollY };
	  } else if (typeof el.scrollLeft !== 'undefined' && typeof el.scrollTop !== 'undefined') {
	    return { x: el.scrollLeft, y: el.scrollTop };
	  }
	
	  return { x: 0, y: 0 };
	}
	//# sourceMappingURL=getScroll.js.map

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedTextPosition;
	
	var _getSelectedText = __webpack_require__(593);
	
	var _getSelectedText2 = _interopRequireDefault(_getSelectedText);
	
	var _getTextWidth = __webpack_require__(588);
	
	var _getTextWidth2 = _interopRequireDefault(_getTextWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @module utils/Positoning/getSelectedTextPosition */
	var ZERO_WIDTH_CHARACTER = '\u200B';
	
	/**
	 * A utility function to attempt to get the current highlighted text position.
	 *
	 * When a context menu is opened, this function attempts to find the bounding client rect
	 * for the highlighted text. However, if the text is in the text field, some weird stuff
	 * happens and it is unable to get it correctly.
	 */
	function getSelectedTextPosition(e) {
	  var height = void 0;
	  var target = e.target,
	      clientX = e.clientX,
	      clientY = e.clientY;
	
	  var text = (0, _getSelectedText2.default)();
	  var width = Math.round((0, _getTextWidth2.default)(text, target) || 0);
	  if (!text || target.classList.contains('md-text-field')) {
	    height = parseInt(window.getComputedStyle(target).fontSize, 10);
	    return {
	      width: width,
	      height: height,
	      left: clientX - width,
	      top: clientY
	    };
	  }
	
	  // All browsers I am supporting have window.getSelection, but better safe than sorry
	  if (window.getSelection) {
	    var selection = window.getSelection();
	    if (selection.rangeCount) {
	      var range = selection.getRangeAt(0).cloneRange();
	      var rect = null;
	      if (range.getClientRects) {
	        var rects = range.getClientRects();
	        if (rects.length > 0) {
	          rect = rects[0];
	        }
	      }
	
	      if (!rect) {
	        var span = document.createElement('span');
	        span.appendChild(document.createTextNode(ZERO_WIDTH_CHARACTER));
	        range.insertNode(span);
	        rect = span.getBoundingClientRect();
	
	        var spanParent = span.parentNode;
	        spanParent.removeChild(span);
	        spanParent.normalize();
	      }
	
	      return rect;
	    }
	  }
	
	  return null;
	}
	//# sourceMappingURL=getSelectedTextPosition.js.map

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTextWidth;
	/** @module utils/Positioning/getTextWidth */
	
	var cachedCanvas = void 0;
	
	/**
	 * A utility function to measure the width (in px) of any text. It will require a canvas
	 * and an element to use to determine the current fonts to apply since different fonts will
	 * have different widths.
	 *
	 * This isn't fully accurate since some browsers handle the calculations a bit differently so
	 * they are off by a 0-3px
	 *
	 * @param {String} text - The text to measure the width
	 * @param {HTMLElement} el - The element to use to determine the current font for the text.
	 * @param {HTMLElement=} canvas - An optional canvas to use for doing the calculations. If this
	 *    is omitted, it will just use the locally created canvas to do the calculations.
	 * @return {number} this will either return null if there is a problem calculating the width or
	 *    the length (in px) of the text.
	 */
	function getTextWidth(text, el, canvas) {
	  if (!el) {
	    return null;
	  }
	
	  if (!canvas) {
	    if (!cachedCanvas) {
	      cachedCanvas = document.createElement('canvas');
	    }
	
	    canvas = cachedCanvas;
	  }
	
	  var context = canvas.getContext('2d');
	  if (!context) {
	    // context doesn't exist in testing without complicated mocks
	    return null;
	  }
	
	  var styles = window.getComputedStyle(el);
	  var font = styles.font;
	  // Some browsers do not actually supply the font style since they are on an older version of CSSProperties,
	  // so the font string needs to be made manually.
	  if (!font) {
	    // font-style font-variant font-weight font-size/line-height font-family
	    var sizing = styles.fontSize + ' / ' + styles.lineHeight + ' ' + styles.fontFamily;
	    font = styles.fontStyle + ' ' + styles.fontVariant + ' ' + styles.fontWeight + ' ' + sizing;
	  }
	
	  context.font = font;
	  return context.measureText(text).width;
	}
	//# sourceMappingURL=getTextWidth.js.map

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isOutOfBounds;
	
	var _getScreenSize = __webpack_require__(233);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isOutHorizontally(fixedTo, child, threshold) {
	  var _fixedTo$getBoundingC = fixedTo.getBoundingClientRect(),
	      fixedLeft = _fixedTo$getBoundingC.left,
	      fixedRight = _fixedTo$getBoundingC.right;
	
	  var _child$getBoundingCli = child.getBoundingClientRect(),
	      childLeft = _child$getBoundingCli.left,
	      childRight = _child$getBoundingCli.right;
	
	  var offset = child.offsetWidth * threshold;
	
	  var left = childLeft + offset;
	  var right = childRight - offset;
	
	  var screenEdge = childLeft === 0 || (0, _getScreenSize2.default)('Width') === childRight;
	  return fixedLeft > left || fixedRight < right || screenEdge;
	} /** @module utils/Positioning/isOutOfBounds */
	
	function isOutVertically(fixedTo, child, toggle, threshold) {
	  var _fixedTo$getBoundingC2 = fixedTo.getBoundingClientRect(),
	      fixedTop = _fixedTo$getBoundingC2.top,
	      fixedBottom = _fixedTo$getBoundingC2.bottom;
	
	  var _child$getBoundingCli2 = child.getBoundingClientRect(),
	      childTop = _child$getBoundingCli2.top,
	      childBottom = _child$getBoundingCli2.bottom;
	
	  var offset = toggle.offsetHeight * threshold;
	
	  var screenEdge = childTop === 0 || (0, _getScreenSize2.default)('Height') === childBottom;
	  return fixedTop > childTop + offset || fixedBottom < childTop - offset || screenEdge;
	}
	
	/**
	 * Checks if the fixedTo object for the Layover component is considered
	 * out of bounds relative to the container.
	 *
	 * @param {Object} fixedTo - The Layover's `fixedTo` prop.
	 * @param {Object} child - The Layover's `children` prop as a DOM element.
	 * @param {Object} toggle - The Layover's `toggle` prop as a DOM element.
	 * @param {number} verticalThreshold - The vertical threshold multiplier to apply.
	 * @param {number} horizontalThreshold - The horizontal threshold multiplier to apply.
	 * @return {boolean} true if the Layover's `fixedTo` prop is considered out of bounds.
	 */
	function isOutOfBounds(fixedTo, child, toggle, verticalThreshold, horizontalThreshold) {
	  if (fixedTo === window) {
	    return false;
	  } else if (fixedTo.x || fixedTo.y) {
	    var x = fixedTo.x,
	        y = fixedTo.y;
	
	    return !!y && isOutVertically(y, child, toggle, verticalThreshold) || !!x && isOutHorizontally(x, child, horizontalThreshold);
	  }
	
	  return isOutVertically(fixedTo, child, toggle, verticalThreshold) || isOutHorizontally(fixedTo, child, horizontalThreshold);
	}
	//# sourceMappingURL=isOutOfBounds.js.map

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = viewport;
	
	var _getScreenSize = __webpack_require__(233);
	
	var _getScreenSize2 = _interopRequireDefault(_getScreenSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Determines if an element is still in the viewport. If it is,
	 * it will return a `true` boolean. If it is not, it will return
	 * an object containing booleans for top, right, bottom, and left
	 * where a `false` value will mean it is out of the viewport for that
	 * position.
	 *
	 * @param {Object} el - The element to test.
	 * @return {boolean|Object} the results.
	 */
	function viewport(el) {
	  if (!el) {
	    return {};
	  }
	
	  var rect = el.getBoundingClientRect();
	  var top = rect.top >= 0;
	  var right = rect.right <= (0, _getScreenSize2.default)('Width');
	  var bottom = rect.bottom <= (0, _getScreenSize2.default)('Height');
	  var left = rect.left >= 0;
	
	  return top && right && bottom && left || { top: top, right: right, bottom: bottom, left: left };
	} /** @module utils/Positioning/viewport */
	//# sourceMappingURL=viewport.js.map

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closest;
	/** @module utils/closest */
	
	/**
	 * A _very_ primitive polyfill for the Element.closest function. If this is a browser that doesn't
	 * support it (IE, Edge, etc), it will just keep searching the parent elements until the nodeName
	 * matches the provided type.
	 *
	 * @param {Element} el - the html element to find a closest node type for
	 * @param {String} type - the html element type to find.
	 * @return {Element} the found element or null.
	 */
	function closest(el, type) {
	  if (typeof el.closest === 'function') {
	    return el.closest(type);
	  }
	
	  var nodeType = type.toUpperCase();
	  var node = el.parentElement;
	  while (node && node.parentElement) {
	    if (node.nodeName === nodeType) {
	      return node;
	    }
	
	    node = node.parentElement;
	  }
	
	  return null;
	}
	//# sourceMappingURL=closest.js.map

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedText;
	/** @module utils/getSelectedText */
	
	/**
	 * A utility function that gets the current selected text in the document. I think
	 * that all the browsers I support have `window.getSelection`, but it falls back to
	 * support others.
	 *
	 * @return {String} the current selection on the page
	 */
	function getSelectedText() {
	  if (typeof window.getSelection !== 'undefined') {
	    return window.getSelection().toString();
	  } else if (typeof document.selection !== 'undefined' && document.selection.type === 'Text') {
	    return document.selection.createRange().text;
	  }
	
	  return '';
	}
	//# sourceMappingURL=getSelectedText.js.map

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapToListParts;
	
	var _react = __webpack_require__(1);
	
	var _Divider = __webpack_require__(557);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Subheader = __webpack_require__(229);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _ListItem = __webpack_require__(566);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @module utils/mapToListParts */
	
	/**
	 * A utility function to convert any "item" into a valid React element that is used
	 * within the `List` component.
	 *
	 * Use cases:
	 * - is a valid React element -> item returned unmodified
	 * - `number` or `string` -> `ListItem` with the item as the `primaryText`
	 * - an `object` with a key `divider: true` -> a `Divider` component with the remaining
	 *    keys applied as props.
	 * - an `object` with a key `subheader: true` -> a `Subheader` component with the remianing
	 *    keys applied as props. This one technically requires the `primaryText` key to be defined.
	 * - an `object` -> all keys passed into the `ListItem` component.
	 *
	 * Examples:
	 * ```js
	 * mapToListParts('Hello') == <ListItem primaryText="Hello" />
	 * mapToListParts(100)     == <ListItem primaryText={100} />
	 * mapToListParts({ primaryText: 'Item' }) == <ListItem primaryText="Item" />
	 * mapToListParts({ divider: true }) == <Divider />
	 * mapToListParts({ subheader: true, primaryText: 'Subheader' }) == <Subheader primaryText="Subheader" />
	 * ```
	 *
	 * @param {string|number|Object} item - the item to convert
	 * @param {number|string=} index - the current index in the array (if used in an array)
	 * @return {Object} a React element
	 */
	function mapToListParts(item, index) {
	  if (typeof item === 'string' || typeof item === 'number') {
	    return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
	  } else if ((0, _react.isValidElement)(item)) {
	    return item;
	  }
	
	  var divider = item.divider,
	      subheader = item.subheader,
	      nestedItems = item.nestedItems,
	      remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);
	
	  var component = void 0;
	  if (divider) {
	    component = _Divider2.default;
	  } else if (subheader) {
	    component = _Subheader2.default;
	  } else {
	    component = _ListItem2.default;
	  }
	
	  var props = _extends({}, remainingProps, { key: item.key || index });
	  if (nestedItems) {
	    props.nestedItems = nestedItems.map(mapToListParts);
	  }
	
	  return (0, _react.createElement)(component, props);
	}
	//# sourceMappingURL=mapToListParts.js.map

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(109);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(156);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(189);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(190);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(136);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(192);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(6);
	
	var _PropTypes = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(41);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _UserLinks = __webpack_require__(44);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	var _SiteConfig = __webpack_require__(7);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var url = _SiteConfig2.default.siteRss;
	    var userLinks = this.props.userLinks;
	    var copyright = _SiteConfig2.default.copyright,
	        fixedFooter = _SiteConfig2.default.fixedFooter;
	
	    if (!copyright) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "footer",
	      { className: fixedFooter ? "footer footer-fixed" : "footer" },
	      userLinks ? _react2.default.createElement(_UserLinks2.default, { config: _SiteConfig2.default, labeled: true }) : null,
	      _react2.default.createElement(
	        "div",
	        { className: "notice-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "copyright" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            copyright
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "rss" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: url },
	            _react2.default.createElement(
	              _Buttons2.default,
	              { flat: true, secondary: true, iconClassName: "fa fa-rss" },
	              "Subscribe"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "based-on" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Based on",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "https://github.com/Vagr9K/gatsby-material-starter" },
	              "Gatsby Material Starter"
	            ),
	            "."
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FontIcons = __webpack_require__(27);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GetNavList(config) {
	  var NavList = [{
	    primaryText: "Home",
	    leftIcon: _react2.default.createElement(
	      _FontIcons2.default,
	      null,
	      "home"
	    ),
	    component: _gatsbyLink2.default,
	    to: "/"
	  }, {
	    divider: true
	  }];
	
	  if (config.userLinks) {
	    config.userLinks.forEach(function (link) {
	      NavList.push({
	        primaryText: link.label,
	        leftIcon: _react2.default.createElement(_FontIcons2.default, { forceSize: true, iconClassName: link.iconClassName }),
	        component: "a",
	        href: link.url
	      });
	    });
	  }
	
	  NavList.push({ divider: true });
	
	  NavList.push({
	    primaryText: "About",
	    leftIcon: _react2.default.createElement(
	      _FontIcons2.default,
	      null,
	      "person"
	    ),
	    component: _gatsbyLink2.default,
	    to: "/about/"
	  });
	  return NavList;
	}
	exports.default = GetNavList;
	module.exports = exports["default"];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavigationDrawers = __webpack_require__(571);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _ToolbarActions = __webpack_require__(271);
	
	var _ToolbarActions2 = _interopRequireDefault(_ToolbarActions);
	
	var _Footer = __webpack_require__(265);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _NavList = __webpack_require__(266);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	__webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        config = _props.config,
	        LocalTitle = _props.LocalTitle;
	
	    var footerLinks = LocalTitle !== "About";
	    return _react2.default.createElement(
	      _NavigationDrawers2.default,
	      {
	        drawerTitle: config.siteTitle,
	        toolbarTitle: LocalTitle,
	        contentClassName: "main-content",
	        navItems: (0, _NavList2.default)(config),
	        mobileDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        tabletDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        desktopDrawerType: _NavigationDrawers2.default.DrawerTypes.TEMPORARY,
	        toolbarActions: _react2.default.createElement(_ToolbarActions2.default, { config: config })
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "main-container" },
	        children
	      ),
	      _react2.default.createElement(_Footer2.default, { userLinks: footerLinks })
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports["default"];

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserLinks = __webpack_require__(44);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	__webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toolbar = function (_Component) {
	  _inherits(Toolbar, _Component);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Toolbar.prototype.render = function render() {
	    var config = this.props.config;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "toolbar-actions" },
	      _react2.default.createElement(
	        "div",
	        { className: "userlinks-container" },
	        _react2.default.createElement(_UserLinks2.default, { config: config })
	      )
	    );
	  };
	
	  return Toolbar;
	}(_react.Component);
	
	exports.default = Toolbar;
	module.exports = exports["default"];

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(41);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	__webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserLinks = function (_Component) {
	  _inherits(UserLinks, _Component);
	
	  function UserLinks() {
	    _classCallCheck(this, UserLinks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UserLinks.prototype.getLinkElements = function getLinkElements() {
	    var userLinks = this.props.config.userLinks;
	    var labeled = this.props.labeled;
	
	    return userLinks.map(function (link) {
	      return _react2.default.createElement(
	        _Buttons2.default,
	        {
	          icon: !labeled,
	          flat: labeled,
	          secondary: true,
	          key: link.label,
	          iconClassName: link.iconClassName,
	          href: link.url
	        },
	        labeled ? link.label : ""
	      );
	    });
	  };
	
	  UserLinks.prototype.render = function render() {
	    var userLinks = this.props.config.userLinks;
	
	    if (!userLinks) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: "user-links" },
	      this.getLinkElements()
	    );
	  };
	
	  return UserLinks;
	}(_react.Component);
	
	exports.default = UserLinks;
	module.exports = exports["default"];

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(522);
	
	var _Navigation = __webpack_require__(267);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SiteConfig = __webpack_require__(7);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(534);
	
	__webpack_require__(533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainLayout = function (_React$Component) {
	  _inherits(MainLayout, _React$Component);
	
	  function MainLayout() {
	    _classCallCheck(this, MainLayout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainLayout.prototype.getLocalTitle = function getLocalTitle() {
	    function capitalize(string) {
	      return string.charAt(0).toUpperCase() + string.slice(1);
	    }
	    var pathPrefix = _SiteConfig2.default.pathPrefix ? _SiteConfig2.default.pathPrefix : "/";
	    var currentPath = this.props.location.pathname.replace(pathPrefix, "").replace("/", "");
	    var title = "";
	    if (currentPath === "") {
	      title = "Home";
	    } else if (currentPath === "tags") {
	      title = "Tags";
	    } else if (currentPath === "categories") {
	      title = "Categories";
	    } else if (currentPath === "about") {
	      title = "About";
	    } else if (currentPath.includes("posts")) {
	      title = "Article";
	    } else if (currentPath.includes("tags")) {
	      var tag = currentPath.replace("tags", "").replace("/", "").replace("-", " ");
	      title = "Tagged in " + capitalize(tag);
	    } else if (currentPath.includes("categories")) {
	      var category = currentPath.replace("categories", "").replace("/", "").replace("-", " ");
	      title = "" + capitalize(category);
	    }
	    return title;
	  };
	
	  MainLayout.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react2.default.createElement(
	      _Navigation2.default,
	      { config: _SiteConfig2.default, LocalTitle: this.getLocalTitle() },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement("meta", { name: "description", content: _SiteConfig2.default.siteDescription })
	        ),
	        children()
	      )
	    );
	  };
	
	  return MainLayout;
	}(_react2.default.Component);
	
	exports.default = MainLayout;
	module.exports = exports["default"];

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-ad448081d32e54d509d3.js